export const translations = {
  ru: {
    pdfImport: {
      processing: 'Распознаём данные PDF. Пожалуйста, дождитесь завершения.',
      busy: 'Сервис распознавания сейчас занят. Повторите загрузку через несколько секунд.',
      timeout: 'Не удалось дождаться обработки PDF. Проверьте данные профиля перед повторной загрузкой.',
      unavailable: 'Распознавание PDF временно недоступно. Попробуйте позже или заполните поля вручную.',
      incompleteHistory: 'Основные данные сохранены. Часть годовых показателей не удалось подтвердить: проверьте и заполните пустые поля перед расчётом.',
      historyRequired: 'Для финансового планирования заполните все шесть годовых показателей. Если значение равно нулю, укажите 0: пустое поле означает, что данные неизвестны.',
    },
    lots: {
      title: 'Поиск лотов',
      subtitle: 'Все лоты госзакупок Казахстана: удобный поиск по категориям товаров, работ и услуг, заказчикам, суммам и регионам',
      searchPlaceholder: 'Наименование или описание лота...',
      categoryBtn: 'Категория ЕНС ТРУ',
      allFilters: 'Все критерии',
      searchBtn: 'Найти',
      searching: 'Ищем лоты…',
      found: 'Найдено лотов',
      empty: 'По вашему запросу лоты не найдены. Попробуйте изменить критерии.',
      tooBroad: 'Запрос слишком широкий и не уложился в лимит времени — добавьте фильтры.',
      searchFailed: 'Не удалось загрузить результаты. Повторите поиск.',
      cursorExpired: 'Сеанс поиска завершён. Начните с первой страницы, чтобы обновить результаты.',
      restartSearch: 'Начать с первой страницы',
      retry: 'Повторить',
      sortDegraded: 'Результаты найдены. Выбранная сортировка временно недоступна; порядок лотов может отличаться.',
      supplierCoverage: 'Поставщики по категории определяются по доступной истории участия. Список может быть неполным.',
      supplierPartial: 'Часть данных о поставщиках категории временно недоступна. Показаны участники найденных закупок.',
      supplierSortDegraded: 'Поставщики найдены. Сортировка по релевантности временно недоступна.',
      count: {
        pending: 'Подсчитываем точное количество…',
        error: 'Не удалось подсчитать количество',
        unavailable: 'Количество пока недоступно',
      },
      pagination: { label: 'Страницы результатов', page: 'Страница' },
      sort: {
        label: 'Сортировка',
        newest: 'Сначала новые',
        relevance: 'По релевантности',
        amountDesc: 'Сумма: по убыванию',
        amountAsc: 'Сумма: по возрастанию',
      },
      filters: {
        subjectType: 'Предмет закупки',
        anySubjectType: 'Все',
        subjectCategoryHint: 'Предмет закупки и выбранные категории ЕНС ТРУ применяются совместно.',
        subjectUnavailable: 'Фильтр предмета закупки временно недоступен. Остальные условия поиска работают.',
        lotNumber: 'Номер лота',
        annoNumber: 'Номер объявления',
        customerBin: 'БИН заказчика',
        customerName: 'Наименование заказчика',
        customerNamePh: 'Например: отдел образования',
        amountFrom: 'Сумма от, ₸',
        amountTo: 'Сумма до, ₸',
        dateFrom: 'Дата обновления, с',
        dateTo: 'Дата обновления, по',
        region: 'Регион поставки',
        allRegions: 'Все регионы',
        status: 'Статус лота',
        tradeMethod: 'Способ закупки',
        anyStatus: 'Все статусы',
        showOtherStatuses: 'Показать остальные статусы',
        hideOtherStatuses: 'Скрыть остальные статусы',
        anyMethod: 'Все способы',
        anyCategory: 'Все категории',
        reset: 'Сбросить фильтры',
      },
      table: {
        lotNumber: '№ Конкурса и лота',
        name: 'Наименование лота',
        customer: 'Заказчик',
        count: 'Количество единиц / п.п.',
        amount: 'Сумма',
        tradeMethod: 'Способ закупки',
        status: 'Статус',
      },
      tabs: {
        general: 'Общие сведения',
        lots: 'Лоты',
        documents: 'Документация',
        discussion: 'Обсуждение',
        protocols: 'Протоколы',
        contracts: 'Договоры',
        appeal: 'Апелляции',
        analytics: 'Аналитика GLauncher',
      },
      card: {
        anno: 'Объявление',
        count: 'Кол-во ед. или п/п',
      },
      picker: {
        title: 'Категории ЕНС ТРУ',
        goods: 'Товары',
        works: 'Работы',
        services: 'Услуги',
        searchPlaceholder: 'Поиск категории по наименованию...',
        wholeSection: 'Выбрать весь раздел',
        codesCount: 'категорий',
        lotsCount: 'лотов',
        allTime: 'Количество лотов за всё время, без дополнительных фильтров',
        countedAt: 'Подсчитано',
        empty: 'Категории не найдены',
        apply: 'Применить',
        clear: 'Очистить',
        selectedLabel: 'Выбрано',
        selectHint: 'Можно выбрать несколько категорий',
        limit: 'Выбрано максимум 20 категорий. Снимите выбор, чтобы добавить другую.',
        remove: 'Убрать категорию',
        close: 'Закрыть без применения',
        back: 'Назад',
        loadFailed: 'Не удалось загрузить категории.',
      },
      detail: {
        notFound: 'Лот не найден',
        backToSearch: 'К поиску лотов',
        onGoszakup: 'Открыть на goszakup.gov.kz',
        lotInfo: 'Сведения о лоте',
        lotNumber: 'Номер лота',
        status: 'Статус лота',
        tradeMethod: 'Способ закупки',
        subjectType: 'Вид предмета закупок',
        finYear: 'Финансовый год',
        description: 'Описание',
        count: 'Количество',
        amount: 'Сумма',
        customerBin: 'БИН заказчика',
        enstru: 'Категория ЕНС ТРУ',
        updated: 'Обновлено',
        annoInfo: 'Объявление',
        sectionsLabel: 'Разделы лота',
        annoNumber: 'Номер объявления',
        annoName: 'Наименование',
        annoStatus: 'Статус объявления',
        organizer: 'Организатор',
        orgBin: 'БИН организатора',
        totalSum: 'Общая сумма объявления',
        lotsCount: 'Кол-во лотов',
        publishDate: 'Опубликовано',
        startDate: 'Начало приёма заявок',
        endDate: 'Окончание приёма заявок',
        itogiDate: 'Итоги',
        noAnno: 'Сведения об объявлении недоступны.',
        currentLot: 'текущий лот',
        noAnnoLots: 'Лоты объявления не найдены.',
        docsUnavailable: 'Ссылки на документы ещё не загружены в нашу базу. Проверьте документы объявления и лота на портале госзакупок.',
        downloadDocument: 'Скачать',
        documentsPartial: 'Показаны доступные в источнике ссылки. Другие документы могут находиться на портале госзакупок.',
        noProtocolFiles: 'Ссылки на файлы протоколов пока не получены. Проверьте документы на портале госзакупок.',
        documentKinds: {
          results: 'Протокол итогов',
          discussion: 'Протокол обсуждения',
          opening: 'Протокол вскрытия',
          document: 'Документ',
        },
        discusStart: 'Начало обсуждения',
        discusEnd: 'Окончание обсуждения',
        discusHint: 'Тексты запросов и ответов обсуждения доступны на портале госзакупок.',
        noDiscussion: 'Обсуждение положений документации по этому объявлению не проводилось либо данные недоступны.',
        noApps: 'Заявки участников пока не опубликованы либо недоступны.',
        appsHint: 'Заявки участников по данному объявлению из протокольных данных портала.',
        appLotUnknown: 'Заявка по объявлению; участие именно в этом лоте не подтверждено загруженными данными.',
        dateApply: 'Дата подачи',
        protNumber: '№ протокола',
        appLotPrice: 'Цена по лоту',
        appLotsCount: 'Лотов в заявке',
        noContracts: 'Договоры по объявлению пока не заключены либо недоступны.',
        noAppeals: 'Сведения об апелляциях доступны на портале госзакупок.',
        noSuppliers: 'Возможные поставщики не найдены.',
        planInfo: 'Пункты плана закупок',
        planPrice: 'Цена за ед.',
        planYear: 'Год',
        contracts: 'Договоры по объявлению',
        contractNumber: '№ договора',
        supplier: 'Поставщик',
        signDate: 'Подписан',
        contractSum: 'Сумма',
        analytics: 'Аналитика GLauncher',
        analyticsUnavailable: 'Недостаточно данных для аналитики по этому лоту.',
        medianAmount: 'Медианная сумма аналогичных конкурсов',
        avgAmount: 'Средняя сумма конкурсов',
        minMax: 'Мин. – Макс. сумма закупки',
        sample: 'Лотов в выборке',
        similarLots: 'Похожих лотов',
        uniqueParticipants: 'Уникальных участников',
        avgApps: 'Заявок на закупку в среднем',
        possibleSuppliers: 'Возможные поставщики',
        possibleSuppliersHint: 'Поставщики подобраны по аналогичным лотам. Показатели — за всю доступную историю поставщика: участия — уникальные конкурсы с заявкой или договором, победы — конкурсы с договором. Сумма всех основных договоров совпадает с аналитикой страницы поставщика; дополнительные соглашения отдельно не суммируются.',
        supplierSearch: 'Поиск по БИН или названию компании',
        showMoreSuppliers: 'Показать еще',
        showLessSuppliers: 'Свернуть до 3 компаний',
        suppliersPartial: 'Данные могут быть неполными: некоторые поставщики или показатели пока недоступны.',
        suppliersError: 'Не удалось загрузить поставщиков. Попробуйте открыть вкладку ещё раз.',
        participations: 'Участия',
        wins: 'Победы',
        wonSum: 'Сумма договоров',
        inRnu: 'РНУ',
        analyticsDisclaimer: 'Аналитика построена на исторических данных портала госзакупок и носит справочный характер.',
      },
    },
    suppliers: {
      title: 'Поставщики',
      subtitle: 'Реестр поставщиков госзакупок Казахстана: поиск по наименованию, БИН и категориям ЕНС ТРУ',
      searchPlaceholder: 'Наименование компании или БИН...',
      found: 'Найдено поставщиков',
      searching: 'Ищем поставщиков…',
      empty: 'Поставщики не найдены. Попробуйте изменить запрос.',
      notFound: 'Поставщик не найден',
      backToSearch: 'К поиску поставщиков',
      table: {
        name: 'Наименование',
        bin: 'БИН',
        region: 'Регион',
        regdate: 'Дата регистрации',
        marks: 'Признаки',
      },
      markSmall: 'Малое предпринимательство',
      markQvazi: 'Квазигоссектор',
      inRnuFull: 'В реестре недобросовестных участников',
      registryInfo: 'Регистрационные данные',
      fullName: 'Полное наименование',
      iin: 'ИИН',
      regdate: 'Дата регистрации',
      kopf: 'Организационно-правовая форма',
      krp: 'КРП (размер предприятия)',
      oked: 'Коды ОКЭД',
      country: 'Страна',
      roles: 'Роли на портале',
      roleSupplier: 'Поставщик',
      roleCustomer: 'Заказчик',
      roleOrganizer: 'Организатор',
      rnuHistory: 'Записи в реестре недобросовестных участников',
      rnuOpen: 'бессрочно',
      contractsCount: 'Договоров',
      contractsSum: 'Сумма договоров',
      applications: 'Подано заявок',
      totalParticipations: 'Участия',
      totalWins: 'Победы',
      historyMetricsHint: 'За всю доступную историю: участия — уникальные конкурсы с заявкой или договором, победы — конкурсы с договором. Сумма договоров учитывает все основные договоры без повторного сложения дополнительных соглашений. «Подано заявок» — количество загруженных записей заявок, не конкурсов.',
      customers: 'Заказчиков',
      topCategories: 'Основные категории закупок',
      topCategoriesHint: 'Категории ЕНС ТРУ, по которым поставщик чаще всего заключал договоры — клик откроет поиск лотов по категории',
      participations: 'Поданные заявки',
      applicationsTitle: 'Заявки',
      applicationCountsHint: 'Число в заголовке и «Поданных заявках» — количество записей поданных заявок. «Победные заявки» — уникальные конкурсы с договором; запись исходной заявки может отсутствовать. Эти показатели не складываются.',
      winningApplications: 'Победные заявки',
      winningHint: 'Уникальные конкурсы, победа в которых подтверждена договором этого поставщика.',
      participationsError: 'Не удалось загрузить заявки. Сверните и откройте блок, чтобы повторить загрузку.',
      lotDataUnavailable: 'Данные лотов пока недоступны',
      lotsIncomplete: 'Состав лотов восстановлен не полностью.',
      analyticsPartial: 'Часть аналитических данных временно недоступна; показатели могут быть неполными.',
      contractsTitle: 'Договоры',
      contractsActive: 'Действующие',
      contractsExecuted: 'Исполненные',
      contractYear: 'Год',
      allYears: 'Все годы',
      contractNumber: 'Номер договора',
      contractAmount: 'Сумма договора',
      contractDate: 'Дата заключения',
      noContracts: 'Договоры с выбранными условиями не найдены.',
      contractsError: 'Не удалось загрузить договоры. Сверните и откройте блок, чтобы повторить загрузку.',
      contractsPartial: 'Данные договоров могут быть неполными. Договоры с неизвестным статусом не включены в эти вкладки.',
      collapse: 'Свернуть',
      noParticipations: 'Заявки поставщика не найдены.',
      partAnno: 'Объявление',
      partDate: 'Дата подачи',
      partLots: 'Лоты',
    },
    news: {
      title: 'Новости',
      subtitle: 'Новости сервиса, обновления и полезные материалы о госзакупках',
      allCategories: 'Все',
      searchPlaceholder: 'Поиск...',
      empty: 'Новостей пока нет',
      featured: 'Главное',
      min: 'мин',
      prev: 'Назад',
      next: 'Далее',
      notFoundTitle: 'Новость не найдена',
      notFoundText: 'Возможно, материал был удалён или ещё не опубликован.',
      backToList: 'Ко всем новостям',
      latestTitle: 'Последние новости',
      sectionTag: 'Новости',
      sectionTitle: 'Новости и обновления',
      sectionAll: 'Все новости',
    },
    nav: {
      main: 'Главная',
      lotsSearch: 'Поиск лотов',
      lots: 'Поиск лотов',
      suppliers: 'Поставщики',
      tracker: 'Отслеживание лотов',
      calculator: 'Финансовый анализ допуска',
      services: 'Сервисы',
      information: 'Информация',
      openMenu: 'Открыть меню',
      closeMenu: 'Закрыть меню',
      switchLanguage: 'Переключить язык на казахский',
      financialPlanning: 'Финансовое планирование',
      experience: 'Расчёт опыта',
      adminPanel: 'Админ-панель',
      contacts: 'Контакты',
      questions: 'Вопросы',
      about: 'О нас',
      news: 'Новости',
      profile: 'Личный кабинет',
      goToProfile: 'Перейти в кабинет',
      logout: 'Выйти',
      login: 'Войти',
      balance: 'Баланс',
      balancePfu: 'ПФУ расчёты',
      balanceVip: 'VIP расчёты',
      balanceSlots: 'Слоты трекера',
      balancePlanning: 'Расчёты планирования',
      balanceTier: 'Расчёты тиров',
      balanceFill: 'Пополнить',
      plans: 'Тарифы',
      subscription: 'Подписка',
      subActive: 'Активна',
      subCancelled: 'Отменена',
      noSubscription: 'Нет тарифа',
      upgradePlan: 'Улучшить тариф',
      viewPlans: 'Смотреть тарифы',
    },
    auth: {
      googleAuthTitle: 'Google Авторизация...',
      googleAuthDesc: 'Пожалуйста, подождите, мы настраиваем ваш аккаунт',
      googleSetupTitle: 'Завершение регистрации',
      googleSetupDesc: 'Пожалуйста, заполните недостающие данные и примите условия для завершения авторизации через Google.',
      finishBtn: 'Завершить',
      loginTitle: 'Вход в аккаунт',
      or: 'или',
      registerNewAccount: 'зарегистрируйте новый аккаунт',
      emailLabel: 'Email адрес',
      passwordLabel: 'Пароль',
      rememberMe: 'Запомнить меня',
      forgotPassword: 'Забыли пароль?',
      loggingIn: 'Вход...',
      loginBtn: 'Войти',
      loginVia: 'Войти через',
      redirecting: 'Перенаправление...',
      registerTitle: 'Создание аккаунта',
      alreadyHaveAccount: 'Уже есть аккаунт?',
      loginToSystem: 'Войдите в систему',
      firstNameLabel: 'Имя',
      lastNameLabel: 'Фамилия',
      phoneLabel: 'Телефон',
      confirmPasswordLabel: 'Подтвердите пароль',
      registering: 'Регистрация...',
      registerBtn: 'Зарегистрироваться',
      registerVia: 'Зарегистрироваться через',
      registerTermsHint1: 'Регистрируясь на сайте, я принимаю условия ',
      registerTermsOffer: 'Публичной оферты',
      registerTermsHint2: ', ',
      registerTermsPrivacy: 'Политики конфиденциальности',
      registerTermsHint3: ' и даю согласие на обработку персональных данных.',
      termsMustBeAccepted: 'Необходимо согласие',
      termsNeedToAcceptError: 'Вам необходимо принять условия и политику для регистрации',
      phoneRequiredError: 'Введите корректный номер телефона',
      legalWarning: 'Автоматизированный сбор данных, сканирование, подбор запросов, обход ограничений и иные попытки неправомерного доступа к информационной системе запрещены и могут повлечь ответственность в соответствии со статьями 205 и 208 Уголовного кодекса Республики Казахстан.',
      forgotPasswordTitle: 'Восстановление пароля',
      forgotPasswordDesc: 'Введите ваш email, и мы отправим код для сброса пароля.',
      sendCodeBtn: 'Отправить код',
      sendingCode: 'Отправка...',
      resetPasswordTitle: 'Сброс пароля',
      resetPasswordDesc: 'Введите код из письма и новый пароль.',
      codeLabel: 'Код верификации',
      newPasswordLabel: 'Новый пароль',
      resetBtn: 'Сбросить пароль',
      resetting: 'Сброс...',
      backToLogin: 'Вернуться ко входу',
      codeSentMsg: 'Код был отправлен на ваш email!',
      passwordResetMsg: 'Пароль успешно изменен. Вы можете войти.',
      passwordRequirements: 'Пароль должен содержать минимум 8 символов, включая 1 заглавную букву и 1 цифру.'
    },
    errors: {
      default: 'Произошла неизвестная ошибка',
      network: 'Ошибка сети',
      invalid_credentials: 'Неверный логин или пароль',
      invalid_code: 'Неверный код верификации',
      user_exists: 'Пользователь с таким email уже существует',
      passwords_mismatch: 'Пароли не совпадают',
      cooldown: 'Подождите перед повторной отправкой',
      too_many_requests: 'Слишком много запросов. Попробуйте позже.',
      unauthorized: 'Сессия истекла. Пожалуйста, войдите снова.',
      google_auth_failed: 'Ошибка авторизации через Google. Попробуйте еще раз.',
      google_client_id_missing: 'Google Client ID не настроен. Проверьте конфигурацию.',
      passwordTooShort: 'Пароль должен содержать минимум 8 символов',
      user_not_found: 'Пользователь не найден',
      google_user_password_reset: 'Невозможно сбросить пароль для аккаунта, зарегистрированного через Google.',
    },
    lang: {
      switch: 'ҚЗ',
    },
    contacts: {
      title: 'Свяжитесь с нами',
      subtitle: 'Мы всегда рады помочь вам с любыми вопросами.',
      address: 'Адрес',
      addressText: 'г. Алматы, ул. Таугуль 52Б',
      phone: 'Телефон',
      phoneText: '+7 707 329 1065',
      email: 'Email',
      emailText: 'support@glauncher.kz',
      formTitle: 'Форма обратной связи',
      formName: 'Ваше имя',
      formNamePlaceholder: 'Ваше имя',
      formEmail: 'Email',
      formEmailPlaceholder: 'ivan@example.com',
      formMessage: 'Сообщение',
      formMessagePlaceholder: 'Опишите ваш вопрос...',
      formSubmit: 'Отправить',
      formSubmitting: 'Отправка...',
      formSuccess: 'Сообщение успешно отправлено! Мы свяжемся с вами в ближайшее время.',
      formErrName: 'Имя должно содержать от 2 до 100 символов',
      formErrEmail: 'Укажите корректный email-адрес',
      formErrMessage: 'Сообщение должно содержать от 10 до 5000 символов',
      formErrCaptcha: 'Не удалось получить токен reCAPTCHA. Попробуйте ещё раз.',
      formErrBot: 'Система защиты отклонила запрос. Пожалуйста, повторите позже.',
      formErrNetwork: 'Ошибка сети. Проверьте соединение и попробуйте ещё раз.',
      captchaDisclaimer: 'Этот сайт защищён reCAPTCHA. Применяются',
      captchaPrivacy: 'Политика конфиденциальности',
      captchaAnd: 'и',
      captchaTerms: 'Условия использования',
      captchaGoogle: 'Google.',
    },
    questions: {
      title: 'Часто задаваемые вопросы (FAQ)',
      q1: 'Как работает финансовый анализ допуска?',
      a1: 'Система рассчитывает балл ПФУ по введённым доходам, налогам и фонду оплаты труда с учётом суммы закупки и категории. Балл ниже максимального сам по себе не означает отказ в допуске.',
      q2: 'Как часто обновляются статусы лотов в трекере?',
      a2: 'Статусы обновляются в автоматическом режиме, чтобы вы всегда имели доступ к самой актуальной информации.',
      q3: 'Безопасно ли хранить данные компании в приложении?',
      a3: 'Все данные компании сохраняются исключительно локально на вашем устройстве (Local Storage), обеспечивая полную конфиденциальность.',
    },
    about: {
      title: 'О платформе G-Launcher',
      subtitle: 'Ваш надежный аналитический партнер в сфере государственных закупок.',
      desc1: 'Наша платформа создана для того, чтобы упростить процесс участия в тендерах для бизнеса. Мы объединяем трекинг лотов, уведомления и предварительный анализ допуска в одном удобном интерфейсе в стиле официальных порталов.',
      desc2: 'С помощью наших алгоритмов проверок вы сможете своевременно оценивать свои шансы на победу и минимизировать риски отклонения заявок.',
      missionTitle: 'Наша миссия',
      missionText: 'Сделать процессы государственного закупа более прозрачными, технологичными и доступными для каждого предпринимателя Республики Казахстан.',
      partnersTitle: 'Компании, сотрудничающие с нами',
    },
    landing: {
      title: 'Платформа для участников Госзакупа',
      subtitle: 'Поиск лотов по категориям ЕНС ТРУ, подписки на новые совпадения, отслеживание выбранных закупок и финансовые расчёты.',
      featuresTitle: 'Инструменты для работы с закупками',
      feat1Desc: 'Отслеживайте выбранную закупку и получайте уведомления в Telegram об изменении её статуса и появлении протокола обсуждения.',
    },
    tracker: {
      title: 'Отслеживание лотов',
      newNotif: 'Новые уведомления',
      searchPlaceholder: 'Поиск по номеру лота или названию...',
      filters: 'Фильтры',
      tabTenders: 'Отслеживаемые лоты',
      tabNotif: 'Уведомления',
      colNumName: 'Номер объявления и наименование',
      colStatus: 'Статус',
      colProtocol: 'Протокол обсуждения',
      emptyNotif: 'Нет новых уведомлений',
      emptyNotifDesc: 'Вы прочитали все системные сообщения.',
      addTrackTender: 'Добавить',
      modalAddTitle: 'Добавить лот',
      modalAddDesc: 'Введите номер объявления (например: 17005447-1), чтобы добавить его в отслеживаемые.',
      modalAddLabel: 'Номер объявления',
      modalAddBtn: 'Добавить в отслеживаемые',
      modalCancelBtn: 'Отмена',
      modalConfirmHint: 'Убедитесь, что номер объявления введён верно. После добавления будет использован один слот трекера.',
      modalConfirmAddBtn: 'Добавить',
      modalAdding: 'Добавление...',
      searchLabel: 'Поиск',
      dateFilterTitle: 'Дата публикации обсуждения',
      dateFilterFrom: 'От',
      dateFilterTo: 'До',
      colActions: 'Действия',
      delete: 'Удалить',
      deleting: 'Удаление...',
      deleteErrorNotFound: 'Лот не найден',
      deleteErrorFormat: 'Неверный формат ID лота',    
      deleteErrorGeneric: 'Ошибка при удалении лота',
      modalDeleteTitle: 'Удаление лота',
      modalDeleteDesc: 'Вы уверены, что хотите удалить лот {numberAnno} из отслеживаемых? Это действие нельзя отменить.',
      modalDeleteBtnConfirm: 'Удалить',
      modalDeleteBtnCancel: 'Отмена',
      noTelegramTitle: 'Telegram не привязан',
      noTelegramDesc: 'Для добавления лотов необходимо привязать Telegram. Вы будете получать уведомления об изменении статусов через нашего бота.',
      noTelegramBtn: 'Привязать Telegram',
      noTelegramLinking: 'Открываем бота...',
      noTelegramLinkError: 'Не удалось получить ссылку. Попробуйте позже.',
      tabHistory: 'История',
      historyContest: 'Номер конкурса',
      historyDate: 'Дата',
      historyStatus: 'Статус',
      historyLastChecked: 'Последняя проверка',
      historyLoading: 'Загрузка истории...',
      historyEmpty: 'История отслеживаний пуста',
      error402: 'Лимит слотов исчерпан.',
      error400: 'Этот конкурс уже отслеживается.',
      error404: 'Конкурс не найден в базе Госзакупок.',
      buyLink: 'Купить слоты',
      pagePrev: '← Назад',
      pageNext: 'Вперёд →',
      pageOf: 'из',
      notifColAnno: 'Номер объявления',
      notifColPlatform: 'Платформа',
      notifColDate: 'Дата',
      notifColTime: 'Время',
      notifColRecipient: 'Получатель',
      notifEmpty: 'Уведомлений пока нет',
      notifEmptyDesc: 'Как только бот отправит уведомление об изменении статуса, оно появится здесь.',
      notifModalTitle: 'Детали уведомления',
      notifModalClose: 'Закрыть',
      notifModalAnno: 'Номер объявления',
      notifModalPlatform: 'Платформа',
      notifModalDate: 'Дата отправки',
      notifModalTime: 'Время отправки',
      notifModalRecipient: 'Получатель',
      notifModalStatus: 'Статус доставки',
      notifModalStatusVal: 'Доставлено',
      notifLoading: 'Загрузка уведомлений...',
      emptyTitle: 'Нет отслеживаемых лотов',
      emptyDesc: 'Добавьте номер объявления, чтобы начать отслеживать изменения и протоколы.',
      searchNoResults: 'Ничего не найдено',
      searchNoResultsDesc: 'Попробуйте другой номер объявления или название.',
      searchClear: 'Очистить поиск',
    },
    billing: {
      tabTitle: 'Доступ и услуги',
      balanceTitle: 'Ваши лимиты',
      pfuLeft: 'Обычных расчётов ПФУ',
      vipLeft: 'VIP-расчётов',
      slotsLeft: 'Активных слотов трекера',
      planningLeft: 'Расчётов планирования',
      tierLeft: 'Расчётов требований по тирам',
      addTitle: 'Докупить лимиты',
      priceLoading: 'Загрузка цен...',
      pfuItem: 'Расчёт ПФУ',
      vipItem: 'VIP-расчёт (макс. сумма)',
      slotItem: 'Слот трекера',
      planningItem: 'Расчёт финансового планирования',
      tierItem: 'Расчёт требований по тирам',
      experienceItem: 'Расчёт опыта',
      priceNotConfigured: 'Розничная покупка пока недоступна',
      experienceDetails: 'Открыть расчёт опыта',
      unknownItem: 'Неизвестная позиция',
      totalLabel: 'Итого к оплате',
      buyBtn: 'Пополнить баланс',
      buying: 'Обработка...',
      buySuccess: '✓ Лимиты успешно начислены!',
      buyError: 'Ошибка при оплате. Попробуйте позже.',
      pieces: 'шт.',
      discountBanner: 'Скидка по тарифу «{plan}» применена к ценам ниже',
      youSave: 'Экономия {amount} ₸',
    },
    plans: {
      heroTag: 'Тарифные планы',
      heroTitle: 'Выберите свой тариф',
      heroSubtitle: 'Экономьте до 60% на услугах платформы. Подключите подписку и получайте расчёты, слоты трекера и планирование каждый месяц — по фиксированной цене.',
      perMonth: 'мес',
      popular: 'Популярный',
      valueLabel: 'Ценность:',
      savings: 'выгода',
      subscribe: 'Подключить',
      switchPlan: 'Сменить тариф',
      currentPlan: 'Текущий тариф',
      currentBannerTitle: 'Ваш активный тариф:',
      currentBannerHint: 'Управлять подпиской можно в личном кабинете',
      manage: 'Управлять',
      loadError: 'Не удалось загрузить тарифы',
      retry: 'Повторить',
      empty: 'Тарифы пока недоступны',
      reassure1Title: 'Отмена в любой момент',
      reassure1Desc: 'Отменяйте подписку когда угодно — она останется активной до конца оплаченного периода.',
      reassure2Title: 'Мгновенное начисление',
      reassure2Desc: 'Услуги пакета начисляются на баланс сразу после подключения тарифа.',
      reassure3Title: 'Скидки на всё остальное',
      reassure3Desc: 'На услуги вне пакета действует персональная скидка при разовой покупке.',
      confirmTitle: 'Подключить тариф?',
      confirmBody: 'Вы подключаете тариф «{plan}» за {price} ₸ в месяц. Услуги будут начислены сразу.',
      confirmSwitchTitle: 'Сменить тариф?',
      confirmSwitchBody: 'Вы переходите на тариф «{plan}» за {price} ₸ в месяц. Новый тариф начнёт действовать немедленно.',
      confirmTestNote: 'Вы будете перенаправлены на защищённую страницу оплаты Halyk Bank.',
      saveCardLabel: 'Сохранить карту для автопродления подписки',
      saveCardHint: 'Данные карты хранятся только в Halyk Bank. Карту можно удалить в профиле в любой момент.',
      cancel: 'Отмена',
      confirmBtn: 'Подключить',
      processing: 'Обработка...',
      subscribeSuccess: '✓ Подписка успешно оформлена!',
      subscribeError: 'Не удалось оформить подписку. Попробуйте позже.',
      methodCard: 'Картой',
      methodQr: 'Halyk QR',
      qrTitle: 'Оплата по Halyk QR',
      qrSubtitle: 'Отсканируйте QR-код в приложении Homebank или другого банка.',
      qrWaiting: 'Ожидаем подтверждение оплаты...',
      qrOpenHomebank: 'Открыть в Homebank',
      qrOpenBankApp: 'Открыть в приложении банка',
      qrFailed: 'Оплата по QR не была завершена. Попробуйте ещё раз.',
      // ── Anchor nav ──
      navSubscriptions: 'Подписки',
      navServices: 'Разовые услуги',
      navTable: 'Прайс-лист',
      showTable: 'Показать полный перечень услуг',
      hideTable: 'Скрыть',
      // ── Guest CTA ──
      loginToSubscribe: 'Войти и подключить',
      loginToBuy: 'Войти и купить',
      guestNote: 'Для оформления покупки нужен аккаунт — вход займёт меньше минуты.',
      // ── Single services section ──
      servicesTag: 'Разовые услуги',
      servicesTitle: 'Отдельные услуги',
      servicesSubtitle: 'Не готовы к подписке? Оплачивайте только то, что нужно прямо сейчас. Разовый платёж, без автопродления.',
      unitCalc: 'за 1 расчёт',
      unitSlot: 'за 1 слот',
      unitMonth: 'в месяц',
      buy: 'Купить',
      selected: 'Выбрано',
      cartTitle: 'Итого к оплате',
      buyNow: 'Оплатить',
      buyProcessing: 'Обработка...',
      buySuccess: '✓ Услуги начислены на баланс!',
      buyError: 'Не удалось оформить покупку. Попробуйте позже.',
      // ── Price table ──
      tableTag: 'Прайс-лист',
      tableTitle: 'Полный перечень услуг и стоимость',
      tableSubtitle: 'Все цены указаны в тенге (₸). Оператор — ТОО «ПИР-Kazakhstan».',
      colService: 'Наименование услуги',
      colUnit: 'Единица',
      colPrice: 'Стоимость',
      colDesc: 'Описание',
      tableSubsGroup: 'Подписки',
      tableServicesGroup: 'Разовые услуги',
      // ── Legal block ──
      legalTitle: 'Правовая информация',
      legalOperator: 'Оператор платформы — ТОО «ПИР-Kazakhstan», БИН 160740018940, Республика Казахстан, г. Алматы, ул. Таугуль 52Б.',
      legalCurrency: 'Все расчёты производятся в тенге (₸, KZT). Оплата принимается через защищённую платёжную страницу банка: VISA, Mastercard, 3D-Secure.',
      legalDocs: 'Оформляя оплату, вы принимаете условия следующих документов:',
      legalOffer: 'Публичная оферта',
      legalPrivacy: 'Политика конфиденциальности',
      legalRefund: 'Возврат и отмена',
      legalSecurity: 'Безопасность платежей',
      // ── Service descriptions ──
      svc: {
        pfuName: 'Расчёт ПФУ',
        pfuDesc: 'Проверка соответствия вашей компании критериям финансовой устойчивости (ПФУ) для участия в конкретном конкурсе. Один расчёт — анализ по одному лоту.',
        vipName: 'VIP-расчёт (максимальная сумма)',
        vipDesc: 'Расширенный расчёт максимальной суммы закупки, в которой компания может участвовать по показателям финансовой устойчивости. Один расчёт — по одному запросу.',
        trackerName: 'Слот трекера',
        trackerDesc: 'Постановка одного лота на отслеживание с автоматическими уведомлениями об изменении статуса, публикации протоколов и итогов. Один слот — один отслеживаемый лот.',
        planningName: 'Расчёт финансового планирования',
        planningDesc: 'Расчёт финансовой модели участия: планирование затрат, авансов и денежного потока по выбранной закупке. Один расчёт — одна финансовая модель.',
        tierName: 'Расчёт требований по тирам',
        experienceName: 'Расчёт опыта',
        experienceDesc: 'Опыт компании по БИН: СМР, проектирование и технический надзор с расшифровкой по объектам. Одна операция включает все поддерживаемые направления.',
        tierDesc: 'Определение требований и ограничений по тирам (категориям) участника для выбранной закупки. Один расчёт — по одному запросу.',
      },
    },
    payment: {
      checkingTitle: 'Проверяем оплату...',
      fulfillingTitle: 'Оплата подтверждена',
      fulfillingBody: 'Выдача доступа ещё обрабатывается. Повторно оплачивать не нужно.',
      fulfillingLater: 'Выдача доступа занимает больше времени. Проверьте личный кабинет чуть позже. Повторно оплачивать не нужно.',
      checkingBody: 'Пожалуйста, подождите — мы уточняем статус платежа в Halyk Bank.',
      successTitle: 'Оплата прошла успешно!',
      successBody: 'Услуги уже начислены на ваш баланс. Спасибо за покупку.',
      goProfile: 'В личный кабинет',
      goPlans: 'К тарифам и услугам',
      failedTitle: 'Оплата не прошла',
      failedBody: 'Платёж не был завершён или был отклонён банком. Попробуйте ещё раз или выберите другой способ оплаты.',
      pendingTitle: 'Оплата обрабатывается',
      pendingBody: 'Банк ещё не подтвердил платёж. Это может занять некоторое время — проверьте статус в личном кабинете чуть позже.',
    },
    subscription: {
      blockTitle: 'Моя подписка',
      statusActive: 'Активна',
      statusCancelled: 'Отменена',
      perMonth: 'мес',
      nextBilling: 'Следующее списание',
      cancelledUntil: 'Подписка отменена. Тариф активен до {date}, затем списания прекратятся.',
      archivedNote: 'Этот тариф больше не предлагается новым клиентам, но продолжает работать для вас. Рекомендуем перейти на актуальный тариф.',
      changePlan: 'Сменить тариф',
      cancelBtn: 'Отменить подписку',
      resumeBtn: 'Возобновить подписку',
      noPlanTitle: 'У вас нет активного тарифа',
      noPlanDesc: 'Подключите подписку и экономьте до 60% на услугах платформы.',
      choosePlan: 'Выбрать тариф',
      cancelSuccess: 'Подписка отменена. Тариф активен до конца периода.',
      resumeSuccess: 'Подписка возобновлена!',
      actionError: 'Не удалось выполнить действие. Попробуйте позже.',
      cancelConfirmTitle: 'Отменить подписку?',
      cancelConfirmBody: 'Подписка останется активной до {date}. После этой даты автопродление и начисления прекратятся.',
      keepBtn: 'Оставить',
      confirmCancelBtn: 'Да, отменить',
      autoRenewOn: 'Автопродление включено — оплата спишется с сохранённой карты автоматически',
      autoRenewOff: 'Автопродление выключено — по окончании периода подписка завершится (нет сохранённой карты)',
      cardsTitle: 'Сохранённые карты',
      cardsHint: 'Карта используется для автопродления подписки. Реквизиты хранятся только в Halyk Bank — мы храним лишь защищённый токен.',
      cardsEmpty: 'Нет сохранённых карт. Карта сохраняется при оплате подписки, если отмечена галочка «Сохранить карту».',
      cardDeleteBtn: 'Удалить',
      cardDeleteConfirm: 'Удалить карту? Автопродление подписки прекратится.',
      cardDeleted: 'Карта удалена',
      cardDeleteError: 'Не удалось удалить карту. Попробуйте позже.',
    },
    calc: {
      title: 'Финансовый анализ допуска',
      subtitle: 'Рассчитайте балл ПФУ компании для выбранной суммы закупки',
      tabAnalysis: 'Анализ конкурса',
      tabHistory: 'История',
      historyEmpty: 'История анализов пуста',
      historyEmptyDesc: 'Запустите первый анализ, и он появится здесь',
      historyDate: 'Дата',
      historyCategory: 'Категория',
      historyAmount: 'Сумма закупки',
      historyType: 'Тип',
      historyStatus: 'ПФУ',
      historyVipLabel: '👑 VIP Потенциал',
      historyPass: 'Максимальный балл',
      historyFail: 'Не максимальный балл',
      historyDetailTitle: 'Детали расчёта',
      historyDetailClose: 'Закрыть',
      historyPrev: '← Назад',
      historyNext: 'Вперёд →',
      historyPageOf: 'из',
      historyLoading: 'Загрузка истории...',
      limitOut: 'У вас закончились расчёты.',
      limitBuyLink: 'Пополнить баланс',
      error402: 'Лимит исчерпан. Пополните баланс в личном кабинете.',
      limitPfu: 'Доступно обычных расчётов',
      limitVip: 'Доступно VIP-расчётов',
      useCompanyBtn: 'Использовать данные моей компании',
      useCompanyApplied: '✓ Данные компании применены',
      categoryLabel: 'Категория закупки',
      categoryPlaceholder: 'Выберите категорию...',
      categoryLoading: 'Загрузка категорий...',
      amountLabel: 'Сумма закупки',
      fieldIncome: 'Доход за 3 года (₸)',
      fieldTaxes: 'Налоги за 3 года (₸)',
      fieldPfot: 'ФОТ за 3 года (₸)',
      btnAnalyze: 'Запустить анализ конкурса',
      confirmTitle: 'Подтвердите запуск анализа',
      confirmDesc: 'Убедитесь, что все финансовые данные компании и сумма закупки введены правильно. После запуска будет списан один расчёт из вашего баланса.',
      confirmBtn: 'Да, запустить',
      confirmCancel: 'Отмена',
      confirmVipTitle: 'Подтвердите VIP-расчёт',
      confirmVipDesc: 'Убедитесь, что финансовые данные компании введены верно. Будет списан один VIP-расчёт из вашего баланса.',
      analyzing: 'Анализируем...',
      vipTitle: 'Максимальный потенциал компании',
      vipDesc: 'Оценим сумму закупки по доходу и ФОТ; показатель налогов проверяется отдельно',
      vipActivate: 'Узнать максимальный потенциал',
      vipDeactivate: 'Калькулятор закупки',
      vipBtn: 'Рассчитать потенциал по ПФУ',
      vipCalculating: 'Рассчитываем...',
      resultPass: 'Компания имеет максимальный балл',
      resultFail: 'Компания имеет не максимальный балл',
      resultScore: 'Итоговый балл',
      resultRequired: 'максимум',
      resultExplanation: 'Балл отражает финансовые показатели компании и сам по себе не определяет допуск к закупке.',
      resultPd: 'ПД — Показатель дохода',
      resultPun: 'ПУН — Уплаченные налоги',
      resultPfot: 'ПФОТ — Фонд труда',
      resultAmountMrp: 'Сумма закупки в МРП',
      resultTierMax: 'Верхняя граница тира',
      vipResultTitle: 'Расчётная сумма закупки',
      vipWarning: 'Предупреждение по ПУН',
      vipPunExplanation: 'Показатель ПУН ({actual}) ниже значения для максимального балла в найденном тире ({target}). ПУН не зависит от суммы закупки, поэтому итоговый балл ПФУ будет ниже максимального.',
      vipPunExplanationFallback: 'Показатель ПУН ниже значения для максимального балла в найденном тире. ПУН не зависит от суммы закупки, поэтому итоговый балл ПФУ будет ниже максимального.',
      noCompanyTitle: 'Профиль компании не заполнен',
      noCompanyDesc: 'Для анализа нужны финансовые данные компании. Введите их вручную или загрузите PDF-выписку с Госзакупок.',
      noCompanyClose: 'Закрыть',
      noCompanySave: 'Применить и запустить',
      noCompanySaving: 'Сохранение...',
      pdfLabel: 'Быстрый импорт из PDF',
      pdfDrop: 'Перетащите PDF-выписку Госзакупок или нажмите для выбора',
      pdfHint: 'Выписка ПФУ со страницы профиля goszakup.gov.kz • макс. 5 МБ',
      pdfParsing: '✨ Магия GLauncher: извлекаем данные...',
      pdfSuccess: 'Данные успешно извлечены!',
      pdfError400: 'Неверный формат или файл > 5 МБ',
      pdfError422: 'Данные не найдены. Загрузите правильный PDF',
      pdfErrorDefault: 'Ошибка при обработке файла',
      pdfHide: 'Скрыть',
      error404: 'Категория не найдена',
      error422: 'Проверьте данные (доход должен быть > 0)',
      error503: 'МРП не настроен на сервере. Обратитесь в поддержку.',
      errorDefault: 'Произошла ошибка. Попробуйте позже.',
    },
    profile: {
      passwordTitle: 'Смена пароля',
      googleAuthNotice: 'Пользователь авторизован с помощью Google',
      oldPasswordLabel: 'Старый пароль',
      newPasswordLabel: 'Новый пароль',
      changePasswordBtn: 'Сменить пароль',
      codeWarning: 'Для завершения смены пароля введите код из письма и новый пароль.',
      updatePasswordBtn: 'Обновить пароль',
      modalTitle: 'Подтверждение',
      modalDesc: 'Отправить код-подтверждение на почту для смены пароля?',
      modalConfirm: 'Да',
      modalCancel: 'Отмена',
      codeLabel: 'Код верификации из Email',
      passwordChangedMsg: 'Пароль успешно изменен',
      codeSentMsg: 'Код для смены пароля отправлен на ваш Email.',
      profileSaved: 'Профиль успешно сохранен.',
      profileSaveError: 'Ошибка при сохранении профиля',
      fillPasswordsRequired: 'Заполните пароль',
      passwordMinLength: 'Пароль должен быть не менее 8 символов',
      editBtn: 'Редактировать',
      saveBtn: 'Сохранить',
      cancelBtn: 'Отмена',
      notifTitle: 'Настройки уведомлений',
      notifDesc: 'Добавьте контакты для получения уведомлений об изменениях статусов лотов через нашего бота.',
      telegramLinked: 'Telegram привязан',
      telegramLinkBtn: 'Привязать Telegram',
      telegramLinking: 'Генерация кода...',
      telegramLinkError: 'Не удалось сгенерировать код. Попробуйте позже.',
      telegramWaiting: 'Ожидаем подтверждения от бота...',
      telegramOpenDesktop: 'Открыть Telegram на ПК',
      telegramOpenMobile: 'Открыть в приложении Telegram',
      telegramZoneDesktop: 'Открыть на компьютере',
      telegramZoneQr: 'Сканировать QR-код',
      telegramZonePin: 'Ввести код вручную',
      telegramQrScan: 'Сканируйте камерой телефона',
      telegramBotName: '@NotifierASPbot',
      telegramPinLabel: 'Код подтверждения:',
      telegramCopyPin: 'Скопировать',
      telegramCopied: 'Скопировано!',
      telegramTimeout: 'Время действия кода истекло. Сгенерируйте новый.',
      telegramSuccessToast: 'Telegram успешно привязан!',
      telegramRetry: 'Новый код',
      telegramUnlink: 'Отвязать',
      telegramUnlinking: 'Отвязываем...',
      telegramUnlinkSuccess: 'Telegram успешно отвязан',
      telegramUnlinkError: 'Не удалось отвязать. Попробуйте позже.',
      sidebarNav: 'Навигация',
      companyTitle: 'Профиль компании',
      companyDesc: 'Используется для автоматического расчёта ПФУ в калькуляторе',
      companyIncome: 'Среднегодовой доход за 3 года (₸)',
      companyTaxes: 'Уплаченные налоги за 3 года (₸)',
      companyPfot: 'Фонд оплаты труда (ФОТ) за 3 года (₸)',
      companyHistoryTitle: 'Данные (по годам)',
      companyHistoryIncomeLabelBase: 'Совокупный годовой доход (100, 110, 130, 150) за',
      companyHistoryTaxesLabelBase: 'Уплаченные налоги за',
      companyHistoryPfotLabelBase: 'Фонд оплаты труда (ФОТ) за',
      companyHistoryYearWord: 'год',
      companySave: 'Сохранить данные компании',
      companySaving: 'Сохранение...',
      companySaved: 'Данные компании сохранены!',
      companySaveError: 'Ошибка при сохранении',
      companyPdfTitle: 'Импорт из PDF',
      companyPdfDrop: 'Перетащите PDF-выписку ПФУ с Госзакупок или нажмите для выбора',
      companyPdfHint: 'Выписка ПФУ со страницы профиля goszakup.gov.kz • макс. 5 МБ',
      companyPdfParsing: '✨ Магия GLauncher: извлекаем данные из PDF...',
      companyPdfSuccess: 'Данные успешно извлечены и сохранены!',
      companyPdfError400: 'Неверный формат файла или размер превышает 5 МБ',
      companyPdfError422: 'Не удалось извлечь данные. Убедитесь, что загружен правильный PDF',
      companyPdfErrorDefault: 'Ошибка при обработке файла',
      security: {
        title: 'Безопасность и устройства',
        sessionsTitle: 'Активные сессии',
        sessionsEmpty: 'Нет активных сессий',
        sessionsLoading: 'Загрузка сессий...',
        sessionTerminate: 'Завершить',
        sessionTerminating: 'Завершение...',
        sessionTerminateConfirmTitle: 'Завершить сессию?',
        sessionTerminateConfirmDesc: 'Устройство будет разлогинено.',
        sessionTerminateSelfTitle: 'Выйти с этого устройства?',
        sessionTerminateSelfDesc: 'Вы удаляете текущую сессию. Вы будете разлогинены с сайта.',
        sessionTerminateSuccess: 'Сессия завершена',
        logoutAll: 'Выйти со всех устройств',
        logoutAllConfirmTitle: 'Выйти со всех устройств?',
        logoutAllConfirmDesc: 'Все другие сессии будут завершены.',
        logoutAllSuccess: 'Все сессии завершены',
        historyTitle: 'История входов',
        historyIp: 'IP-адрес',
        historyDate: 'Время входа',
        historyEmpty: 'Нет истории входов',
        unknownDevice: 'Неизвестное устройство',
        errNetwork: 'Ошибка сети. Попробуйте ещё раз.',
        logoutAllLoading: 'Выход...',
        currentSession: 'Текущая сессия',
      },
      payments: {
        title: 'История оплат',
        subtitle: 'Ваши последние транзакции и покупки',
        colDate: 'Дата',
        colServices: 'Услуги',
        colAmount: 'Сумма',
        colStatus: 'Статус',
        empty: 'Пока нет оплат',
        emptyDesc: 'Здесь появится история ваших покупок и подписок',
        loading: 'Загрузка истории...',
        error: 'Не удалось загрузить историю оплат',
        retry: 'Повторить',
        statusPaid: 'Оплачено',
        statusPending: 'В обработке',
        statusFailed: 'Ошибка',
        statusRefunded: 'Возврат',
        subscription: 'Подписка',
        subRenewal: 'Продление подписки',
      },
    },
    fp: {
      title: 'Финансовое планирование',
      subtitle: 'Обратный калькулятор: узнайте, какие показатели нужно нарастить для выхода на целевую сумму закупки',
      tabPlanning: 'Планирование',
      tabHistory: 'История',
      companyDataTitle: 'Финансовые данные компании',
      useCompanyBtn: 'Использовать данные моей компании',
      useCompanyApplied: '✓ Данные компании применены',
      categoryLabel: 'Категория закупки',
      categoryPlaceholder: 'Выберите категорию...',
      amountLabel: 'Целевая сумма закупки (₸)',
      mrpLabel: 'МРП (изменение)',
      mrpBase: 'Базовый МРП',
      mrpCustom: 'Кастомный МРП',
      mrpHint: 'Движком задайте процент изменения МРП (+5 %…+10 %)',
      yearLabel: 'Год планирования',
      yearValidation: 'Нельзя выбрать год меньше текущего',
      historyIncome1: 'Доход за Год−24 (₸)',
      historyTaxes1: 'Налоги за Год−24 (₸)',
      historyPfot1: 'ФОТ за Год−24 (₸)',
      historyIncome2: 'Доход за Год−23 (₸)',
      historyTaxes2: 'Налоги за Год−23 (₸)',
      historyPfot2: 'ФОТ за Год−23 (₸)',
      historyDataTitle: 'Данные (для расчёта целевого года)',
      historyIncomeLabelBase: 'Совокупный годовой доход (100, 110, 130, 150) за',
      historyTaxesLabelBase: 'Уплаченные налоги за',
      historyPfotLabelBase: 'Фонд оплаты труда (ФОТ) за',
      historyYearWord: 'год',
      btnCalculate: 'Запустить анализ планирования',
      confirmTitle: 'Подтвердите запуск анализа',
      confirmPlanDesc: 'Убедитесь, что исторические данные и сумма закупки указаны верно. Будет списан один расчёт планирования.',
      confirmTierDesc: 'Убедитесь, что исторические данные указаны верно. Будет списан один расчёт требований по тирам.',
      confirmBtn: 'Да, запустить',
      confirmCancel: 'Отмена',
      analyzing: 'Анализируем...',
      tierBannerTitle: 'Минимальные требования по тирам',
      tierBannerDesc: 'Узнайте пороговые фин. показатели для каждого тира выбранной категории при изменении МРП',
      tierBannerBtn: 'Показать требования по тирам',
      tierBannerBtnBack: 'Вернуться к планированию суммы',
      btnTier: 'Рассчитать требования по тирам',
      tierCalcRunning: 'Расчитываем...',
      scenarioCustom: 'Кастомный МРП',
      scenarioMrp5: '+5 % МРП',
      scenarioMrp10: '+10 % МРП',
      scenarioBase: 'Базовый МРП',
      scenarioBaseHint: '(Текущий МРП, для справки)',
      resultReqPfu: 'Требуемый ПФУ',
      resultPdMin: 'Мин. ПД (доход)',
      resultPunMin: 'Мин. ПУН (налоги)',
      resultPfotMin: 'Мин. ПФОТ',
      resultIncome3yrs: 'Мин. доход за 3 года (₸)',
      resultTaxes3yrs: 'Мин. налоги за 3 года (₸)',
      resultPfot3yrs: 'Мин. ФОТ за 3 года (₸)',
      resultTargetTitle: 'Надо добрать в целевом году (₸)',
      resultTargetIncome: 'Доход',
      resultTargetTaxes: 'Налоги',
      resultTargetPfot: 'ФОТ',
      targetYearDone: 'Выполнено',
      resultMrpValue: 'Значение МРП',
      resultAmountMrp: 'Сумма в МРП',
      resultPurchaseAmount: 'Сумма закупки',
      resultTitle: 'Результаты расчёта',
      resultYearsTitle: 'Расчётные годы',
      resultYear1: 'Год 1',
      resultYear2: 'Год 2',
      resultYear3target: 'Целевой год',
      tierLabel: 'Тир',
      tierReqPfu: 'Требуемый ПФУ',
      tierReqPd: 'Треб. ПД',
      tierReqPun: 'Треб. ПУН',
      tierReqPfot: 'Треб. ПФОТ',
      noCompanyTitle: 'Профиль компании не заполнен',
      noCompanyDesc: 'Для расчёта нужны финансовые данные компании.',
      noCompanyClose: 'Закрыть',
      limitPlanning: 'Доступно расчётов планирования',
      limitTier: 'Доступно расчётов тиров',
      limitBuyLink: 'Пополнить баланс',
      error402: 'Лимит исчерпан. Пополните баланс в личном кабинете.',
      error404: 'Категория не найдена',
      error422: 'Проверьте данные (сумма должна быть > 0)',
      errorDefault: 'Произошла ошибка. Попробуйте позже.',
      historyEmpty: 'История планирования пуста',
      historyEmptyDesc: 'Запустите первый расчёт, и он появится здесь',
      historyDate: 'Дата',
      historyCategory: 'Категория',
      historyAmount: 'Целевая сумма',
      historyType: 'Тип',
      historyTypePlanning: 'Планирование',
      historyTypeTier: 'Анализ тиров',
      historyDetailTitle: 'Детали расчёта',
      historyDetailClose: 'Закрыть',
      pdfLabel: 'Быстрый импорт из PDF',
      pdfDrop: 'Перетащите PDF-выписку Госзакупок или нажмите для выбора',
      pdfHint: 'Выписка ПФУ со страницы профиля goszakup.gov.kz • макс. 5 МБ',
      pdfParsing: '✨ Магия GLauncher: извлекаем данные...',
      pdfSuccess: 'Данные успешно извлечены!',
      pdfError400: 'Неверный формат или файл > 5 МБ',
      pdfError422: 'Данные не найдены. Загрузите правильный PDF',
      pdfErrorDefault: 'Ошибка при обработке файла',
      pdfHide: 'Скрыть',
    },
    admin: {
      title: 'Административная панель',
      statMillions: 'млн ₸',
      statThousands: 'тыс ₸',
      statDays7: '7д',
      statDays30: '30д',
      statPfu: 'ПФУ',
      tierPrefix: 'Тир',
      tiersCount: 'Тиров',

      badge: 'ADMIN',
      navDashboard: 'Дашборд',
      navUsers: 'Пользователи',
      navBilling: 'Биллинг',
      navSubscriptions: 'Подписки',
      navSettings: 'Настройки ПФУ',
      navTenders: 'Трекер тендеров',
      navAuditLog: 'Журнал изменений',
      accessDenied: 'Доступ запрещён',
      accessDeniedDesc: 'У вас недостаточно прав для просмотра этой страницы.',
      backToSite: 'На главный сайт',
      loading: 'Загрузка...',
      errorLoad: 'Ошибка загрузки данных',
      retry: 'Повторить',
      save: 'Сохранить',
      saving: 'Сохранение...',
      saved: 'Сохранено',
      cancel: 'Отмена',
      delete: 'Удалить',
      deleting: 'Удаление...',
      edit: 'Редактировать',
      create: 'Создать',
      confirm: 'Подтвердить',
      search: 'Поиск',
      searchPlaceholder: 'Email, имя, телефон...',
      noData: 'Нет данных',
      total: 'Всего',
      actions: 'Действия',
      yes: 'Да',
      no: 'Нет',
      close: 'Закрыть',
      from: 'с',
      to: 'по',
      period: 'Период',
      status: 'Статус',
      all: 'Все',
      of: 'из',
      pagePrev: '← Назад',
      pageNext: 'Вперёд →',

      // Dashboard
      dashboardTitle: 'Обзор платформы',
      statTotalUsers: 'Всего пользователей',
      statNewToday: 'Новых за 24 ч',
      statNewWeek: 'Новых за неделю',
      statNewMonth: 'Новых за месяц',
      statActiveToday: 'Активных за 24 ч',
      statActiveMonth: 'Активных за 30 д',
      statTotalRevenue: 'Выручка всего',
      statMrr: 'MRR (текущий месяц)',
      statTotalOrders: 'Всего заказов',
      statPfuBurns: 'Сожжено ПФУ за 24 ч',
      statTrackerBurns: 'Трекер-событий за 24 ч',
      statBurnRateRatio: 'Burn Rate 24h: ПФУ vs Tracker',
      chartRegistrations: 'Регистрации за 30 дней',
      chartDate: 'Дата',
      chartCount: 'Кол-во',

      // Users
      usersTitle: 'Управление пользователями',
      filterActive: 'Активные',
      filterInactive: 'Неактивные',
      filterTelegram: 'Telegram',
      filterAll: 'Все',
      filterHasTg: 'Есть Telegram',
      filterNoTg: 'Нет Telegram',
      colEmail: 'Email',
      colName: 'Имя',
      colPhone: 'Телефон',
      colTelegram: 'Telegram',
      colActive: 'Активен',
      colVerified: 'Верифицирован',
      colRole: 'Роль',
      colBalance: 'Баланс (ПФУ/VIP/Слоты)',
      colRegistered: 'Дата регистрации',
      colLastLogin: 'Последний вход',
      colIncome: 'Доход 3 года (₸)',
      viewDetail: 'Подробнее',
      userDetailTitle: 'Профиль пользователя',
      tabProfile: 'Профиль',
      tabBalance: 'Баланс',
      tabHistory: 'История',
      balanceTitle: 'Управление балансом',
      balancePfu: 'ПФУ расчёты',
      balanceVip: 'VIP расчёты',
      balanceTracker: 'Слоты трекера',
      balancePlanning: 'Расчёты планирования',
      balanceTier: 'Расчёты тиров',
      balanceDeltaHint: 'Введите положительное или отрицательное число (−3 = списать 3)',
      balanceReasonLabel: 'Причина изменения',
      balanceReasonPlaceholder: 'Например: компенсация, акция, ошибочный заказ',
      balanceApply: 'Применить изменение',
      balanceApplying: 'Применение...',
      balanceSuccess: 'Баланс успешно обновлён',
      balanceError: 'Ошибка обновления баланса',
      roleTitle: 'Роль пользователя',
      roleChange: 'Изменить роль',
      roleChanging: 'Изменение...',
      roleChanged: 'Роль изменена',
      unlockTitle: 'Блокировка аккаунта',
      unlockBtn: 'Разблокировать',
      unlocking: 'Разблокировка...',
      unlocked: 'Аккаунт разблокирован',
      lockedUntil: 'Заблокирован до',
      lockTitle: 'Заблокировать аккаунт',
      lockBtn: 'Заблокировать',
      locking: 'Блокировка...',
      lockConfirmBody: 'Вы уверены, что хотите заблокировать аккаунт? Пользователь не сможет войти до отмены.',
      accountBlocked: 'Аккаунт заблокирован администратором',
      accountRateLocked: 'Аккаунт заблокирован по превышению попыток',
      activateBtn: 'Активировать',
      activating: 'Активация...',
      historySourcePfu: 'ПФУ расчёт',
      historySourcePlanning: 'Планирование',
      historySourceTracker: 'Трекер',
      historyEmpty: 'История пуста',

      // Billing tabs
      billingTabOrders: 'Транзакции',
      billingTabPrices: 'Управление ценами',

      // Orders
      billingTitle: 'Биллинг и транзакции',
      colOrderId: 'Order ID',
      colAmount: 'Сумма',
      colCurrency: 'Валюта',
      colOrderStatus: 'Статус',
      colItems: 'Позиции',
      colDate: 'Дата',
      statusPaid: 'Оплачен',
      statusPending: 'Ожидание',
      statusFailed: 'Ошибка',
      statusRefunded: 'Возвращён',
      filterStatusAll: 'Все статусы',

      // Refund
      refundBtn: 'Вернуть',
      refundConfirmTitle: 'Подтвердить возврат',
      refundConfirmDesc: 'Вернуть средства по заказу {id} на сумму {amount}? Токены пользователя будут списаны.',
      refunding: 'Возврат...',
      refundSuccess: 'Возврат выполнен',
      refundError: 'Ошибка возврата',

      // CSV export
      exportCsv: 'Экспорт CSV',
      exportExcel: 'Экспорт Excel',

      // Prices tab
      pricesTitle: 'Управление ценами на услуги',
      pricesSubtitle: 'Изменения применяются ко всем новым покупкам немедленно.',
      priceService: 'Услуга',
      priceAmount: 'Цена (₸)',
      priceEdit: 'Изменить',
      priceConfirmTitle: 'Подтвердить изменение цены',
      priceConfirmDesc: 'Вы изменяете цену «{label}» с {old} ₸ на {new} ₸. Это немедленно повлияет на стоимость для всех новых покупок.',
      priceSave: 'Сохранить цену',
      priceSaving: 'Сохранение...',
      priceSaved: 'Цена обновлена',
      priceNotConfigured: 'Цена не задана. Розничная покупка недоступна до настройки.',
      balanceExperience: 'Расчёты опыта',
      priceError: 'Ошибка обновления цены',
      priceCancel: 'Отмена',
      priceConfirm: 'Да, обновить',
      priceLoading: 'Загрузка цен...',

      // Subscriptions
      subsTitle: 'Подписки',
      subsTabPlans: 'Тарифы',
      subsTabSubscribers: 'Подписчики',
      subsCreatePlan: 'Создать тариф',
      subsMonth: 'мес',
      subsUnit: 'шт',
      subsFilterAll: 'Все',
      subsNoPlans: 'Тарифы ещё не созданы',
      subsNoSubscribers: 'Подписчиков пока нет',
      // Plan card / statuses
      subsStatusDraft: 'Черновик',
      subsStatusActive: 'Активный',
      subsStatusArchived: 'Архив',
      subsRetailValue: 'Ценность пакета',
      subsRetailValueHint: 'Стоимость включённых услуг по розничным ценам',
      subsEdit: 'Изменить',
      subsActivate: 'Активировать',
      subsArchive: 'Архивировать',
      subsDelete: 'Удалить',
      // Plan form
      subsNewPlan: 'Новый тариф',
      subsEditPlan: 'Редактирование тарифа',
      subsPlanName: 'Название тарифа',
      subsPlanNamePlaceholder: 'Например: Стандарт',
      subsPlanDesc: 'Описание',
      subsPlanDescPlaceholder: 'Краткое описание для клиентов...',
      subsPlanPrice: 'Цена в месяц',
      subsSortOrder: 'Порядок сортировки',
      subsFeatured: 'Рекомендуемый',
      subsFeaturedHint: 'Выделять на странице тарифов',
      subsServiceConditions: 'Условия по услугам',
      subsColService: 'Услуга',
      subsColIncluded: 'Включено (шт/мес)',
      subsColDiscount: 'Скидка (если не входит)',
      subsSave: 'Сохранить',
      subsSaving: 'Сохранение...',
      subsErrName: 'Укажите название тарифа',
      subsErrPrice: 'Укажите корректную цену',
      subsErrorSave: 'Ошибка сохранения тарифа',
      // Plan actions feedback
      subsCreated: 'Тариф создан (черновик)',
      subsUpdated: 'Тариф обновлён',
      subsActivated: 'Тариф активирован',
      subsArchivedMsg: 'Тариф перемещён в архив',
      subsDeletedMsg: 'Тариф удалён',
      subsDeleteBlocked: 'Нельзя удалить тариф с активными подписчиками — сначала архивируйте его',
      // Confirm modals
      subsArchiveConfirmTitle: 'Архивировать тариф?',
      subsArchiveConfirmBody: 'На этом тарифе {count} активных подписчиков. Новые подписки станут недоступны, существующие клиенты продолжат пользоваться тарифом.',
      subsDeleteConfirmTitle: 'Удалить тариф?',
      subsDeleteConfirmBody: 'Тариф будет удалён безвозвратно. Это возможно только если на нём нет активных подписчиков.',
      // Subscribers tab
      subsColClient: 'Клиент',
      subsColPlan: 'Тариф',
      subsColStatus: 'Статус',
      subsColStarted: 'Подписан с',
      subsColNextBilling: 'Следующее списание',
      subsColLastPayment: 'Последний платёж',
      subsSubStatusActive: 'Активна',
      subsSubStatusCancelled: 'Отменена',
      subsSubStatusExpired: 'Истекла',
      subsActiveUntil: 'активна до',
      subsFilterByPlan: 'Все тарифы',
      orderSubscription: 'Подписка (подключение)',
      orderSubRenewal: 'Подписка (продление)',

      // Settings
      settingsTitle: 'Настройки системы и ПФУ',
      mrpTitle: 'Глобальные настройки',
      mrpLabel: 'Текущий МРП (₸)',
      mrpHint: 'Значение МРП влияет на все расчёты ПФУ в реальном времени.',
      mrpSave: 'Обновить МРП',
      mrpSaving: 'Сохранение...',
      mrpSaved: 'МРП обновлён',
      mrpError: 'Ошибка обновления МРП',
      categoriesTitle: 'Категории ПФУ',
      categoryKey: 'Ключ (key)',
      categoryName: 'Название',
      categoryCoefficients: 'Коэффициенты',
      categoryTiers: 'Тиры',
      addCategory: 'Добавить категорию',
      editCategory: 'Редактировать категорию',
      deleteCategory: 'Удалить категорию',
      deleteCategoryConfirm: 'Вы уверены, что хотите удалить категорию «{name}»? Это повлияет на все расчёты.',
      minPd: 'min_pd_value',
      multPd: 'mult_pd',
      minPun: 'min_pun_value',
      multPun: 'mult_pun',
      minPfot: 'min_pfot_value',
      multPfot: 'mult_pfot',
      tierMaxMrp: 'max_mrp (null = без ограничения)',
      tierReqPd: 'req_pd',
      tierReqPun: 'req_pun',
      tierReqPfot: 'req_pfot',
      tierReqPfu: 'req_pfu',
      addTier: 'Добавить тир',
      removeTier: 'Удалить тир',
      categoryCreated: 'Категория создана',
      categoryUpdated: 'Категория обновлена',
      categoryDeleted: 'Категория удалена',
      categoryError: 'Ошибка сохранения категории',

      // Tenders
      tendersTitle: 'Мониторинг трекера и воркеров',
      colAnno: 'Номер объявления',
      colUserId: 'ID пользователя',
      colDiscussion: 'Протокол',
      colNotifPlatform: 'Уведомление',
      colCreated: 'Создан',
      colUpdated: 'Обновлён',

      // Tracker page
      trackerStatTotal: 'Всего записей',
      trackerStatProtocol: 'Протокол получен',
      trackerStatNotified: 'Оповещены',
      trackerStatUnique: 'Уникальных тендеров',
      trackerStatUsers: 'Пользователей',
      trackerSearchPlaceholder: 'Поиск по номеру объявления...',
      trackerFilterWaiting: 'Ждут протокол',
      trackerFilterFound: 'Протокол вышел',
      trackerFilterNotified: 'Уведомлены',
      trackerColUser: 'Пользователь',
      trackerColStatus: 'Статус тендера',
      trackerProtocolYes: 'Вышел',
      trackerProtocolNo: 'Не вышел',

      // Worker health
      workerTitle: 'Статус воркера',
      workerRedis: 'Redis / Celery',
      workerRedisOk: 'Доступно',
      workerRedisErr: 'Недоступно',
      workerLastRun: 'Последний запуск',
      workerNeverRun: 'Никогда не запускался',
      workerJustNow: 'Только что',
      workerMinsAgo: 'мин. назад',
      workerHrsAgo: 'ч. назад',
      workerRunStatus: 'Результат',
      workerStatusOk: 'Успешно',
      workerStatusRunning: 'Выполняется',
      workerStatusError: 'Ошибка',
      workerChecked: 'Проверено',
      workerNotified: 'Уведомлений',
      workerStatusChanges: 'Смен статуса',
      workerScheduleDesc: 'Расписание: каждые {n} мин.',
      workerTriggerBtn: 'Запустить сейчас',
      workerTriggering: 'Запуск...',
      workerTriggerSuccess: 'Задача ставится в очередь',
      workerTriggerError: 'Ошибка запуска',

      // Force sync
      forceSyncTitle: 'Force Sync',
      forceSyncDesc: 'Принудительная проверка тендера из Госзакуп по номеру объявления.',
      forceSyncPlaceholder: 'Номер объявления (напр.: 17005447-1)',
      forceSyncBtn: 'Проверить',
      forceSyncRunning: 'Проверка...',
      forceSyncFound: 'Тендер найден в Госзакуп',
      forceSyncNotFoundOws: 'Тендер не найден в Госзакуп',
      forceSyncNotInDb: 'Система не отслеживает этот номер',
      forceSyncProtocolFound: 'Протокол обсуждения обнаружен',
      forceSyncNoProtocol: 'Протокол обсуждения не обнаружен',
      forceSyncStatusChanged: 'Статус изменился',
      forceSyncNoChanges: 'Изменений нет',
      forceSyncUpdated: 'Записей обновлено',

      // Audit log
      auditTitle: 'Журнал административных действий',
      auditAdmin: 'Администратор',
      auditAction: 'Действие',
      auditTarget: 'Целевой пользователь',
      auditDetail: 'Детали',
      auditDate: 'Дата',
      auditExport: 'Экспорт Excel',
      auditSearchAdmin: 'Поиск по email админа',
      auditFilterAllActions: 'Все действия',
      auditDateFrom: 'С',
      auditDateTo: 'По',
      auditClearFilters: 'Сбросить фильтры',
      auditColSummary: 'Описание',
      auditDetailTitle: 'Детали действия',
      auditDetailAdmin: 'Администратор',
      auditDetailTarget: 'Пользователь',
      auditDetailData: 'Данные действия',
      auditShowJson: 'JSON',
      auditHideJson: 'Скрыть JSON',
      // Action labels
      auditAction_balance_update: 'Баланс',
      auditAction_role_change: 'Роль',
      auditAction_toggle_active: 'Активация',
      auditAction_account_unlock: 'Разблокировка',
      auditAction_contact_update: 'Контакты',
      auditAction_welcome_bonus: 'Бонус',
      auditAction_admin_reset_password: 'Сброс пароля',
      auditAction_order_refund: 'Возврат',
      auditAction_price_update: 'Цена',
      auditAction_mrp_update: 'МРП',
      auditAction_category_create: 'Категория ++',
      auditAction_category_update: 'Категория',
      auditAction_category_delete: 'Категория --',
      auditAction_worker_trigger: 'Воркер',
      auditAction_force_sync: 'Force Sync',
      auditAction_subscription_plan_create: 'Тариф ++',
      auditAction_subscription_plan_update: 'Тариф',
      auditAction_subscription_plan_activate: 'Тариф вкл.',
      auditAction_subscription_plan_archive: 'Тариф архив',
      auditAction_subscription_plan_delete: 'Тариф --',
      auditAction_document_create: 'Документ ++',
      auditAction_document_update: 'Документ',
      auditAction_document_publish: 'Публикация',
      auditAction_document_restore: 'Восстановление',
      auditAction_document_delete: 'Документ --',
      calcTypeReversePlanning: 'Обратное планирование',
      calcTypeTierRequirements: 'Требования по тирам',

      // History sub-tabs
      tabLoginHistory: 'Входы',
      tabBillingHistory: 'Покупки',
      tabActivityHistory: 'Активность',
      loginHistoryIp: 'IP-адрес',
      loginHistoryDate: 'Дата входа',
      loginHistoryEmpty: 'История входов пуста',
      billingHistoryEmpty: 'Покупок пока нет',

      // Welcome bonus
      welcomeBonus: 'Начислить приветственный бонус',
      welcomeBonusSending: 'Начисление...',
      welcomeBonusSuccess: 'Приветственный бонус начислен!',
      welcomeBonusError: 'Ошибка начисления бонуса',
      welcomeBonusDesc: 'Начисляет стандартный набор токенов (5 ПФУ, 3 слота трекера, 3 планирования, 5 тиров)',

      // Reset password
      resetPasswordBtn: 'Сгенерировать код сброса пароля',
      resetPasswordGenerating: 'Генерация...',
      resetPasswordSuccess: 'Код сгенерирован и отправлен на email',
      resetPasswordError: 'Ошибка генерации кода',
      resetPasswordCode: 'Код сброса пароля',
      resetPasswordExpires: 'Действует до',
      resetPasswordCopy: 'Скопировать',
      resetPasswordCopied: 'Скопировано!',

      // Contact edit
      editContactTitle: 'Редактировать контактные данные',
      contactName: 'Имя',
      contactSurname: 'Фамилия',
      contactPhone: 'Телефон',
      contactWhatsapp: 'WhatsApp',
      contactSave: 'Сохранить',
      contactSaving: 'Сохранение...',
      contactSaved: 'Контакты обновлены',
      contactError: 'Ошибка сохранения',

      // Clients/Staff tabs
      tabClients: 'Клиенты',
      tabStaff: 'Сотрудники',
      staffDesc: 'Сотрудники имеют доступ к административным функциям.',
      filterRoleAll: 'Все роли',
      addStaff: 'Добавить сотрудника',
      addStaffTitle: 'Добавить сотрудника',
      addStaffDesc: 'Найдите пользователя из списка и назначьте ему роль сотрудника.',
      addStaffSearch: 'Поиск по email, имени или телефону...',
      addStaffSelectRole: 'Выберите роль',
      addStaffRoleHint: 'analyst — чтение, manager — управление пользователями, superadmin — полный доступ.',
      addStaffConfirm: 'Назначить роль',
      addStaffConfirming: 'Назначение...',
      addStaffSuccess: 'Роль успешно назначена',
      addStaffError: 'Ошибка при назначении роли',

      // Activate/Deactivate
      activateUser: 'Активировать',
      deactivateUser: 'Деактивировать',
      activateSuccess: 'Статус пользователя изменён',
      activateError: 'Ошибка изменения статуса',

      // Confirm dialogs
      confirmRoleChange: 'Вы уверены, что хотите изменить роль этого пользователя?',
      confirmBonus: 'Выдать приветственный бонус этому пользователю?',
      confirmReset: 'Сгенерировать код сброса пароля для этого пользователя?',

      // History labels
      historyCategory: 'Категория',
      historyPasses: 'Максимальный балл',
      historyCalcType: 'Тип расчёта',
      historyContest: 'Конкурс',
      historyStatus: 'Статус',

      // Charts
      chartRevenue: 'Выручка за 30 дней',
      chartRevenue30dSub: 'Динамика выручки за последние 30 дней',
      chartFeatureUsage: 'Потребление фичей за 30 дней',
      chartFeatureUsageSub: 'ПФУ, отслеживание и расчёт опыта по дням',
      chartRevenueY: 'Выручка (₸)',
      chartRegistrationsY: 'Регистрации',
      chartRegistrationsSub: 'Новые пользователи за последние 30 дней',
      lastUpdated: 'Данные актуальны на',
      statRevenueMonth: 'Выручка за месяц',
      statRevenue30d: 'Выручка 30д',
      statArpu: 'ARPU',
      statOrders30d: 'Заказов за 30 дней',
      statAvgOrder: 'Средний чек',
      statVerified: 'Верифицировано',
      statPlanningBurns: 'Планирование 24ч',
      statExperienceBurns: 'Расчёт опыта 24ч',
      experienceUsage30d: 'Расчёт опыта за 30д',
      statActiveUsers: 'Активные пользователи',
      statActiveUsersDesc: 'Доля активных от всех пользователей',
      featureBurns: 'Использование сервисов',
      featureBurnsDesc: 'Количество вызовов за 24 часа',
      platformHealth: 'Здоровье платформы',
      platformHealthDesc: 'Финансовые показатели платформы',
      productBreakdown: 'Выручка по продуктам',
      productBreakdownSub: 'Распределение оплаченных заказов',
      recentSignups: 'Последние регистрации',
      recentOrders: 'Последние покупки',

      // Site settings
      navSiteSettings: 'Настройки сайта',
      navPromotions: 'Реклама',
      siteSettings: {
        title: 'Настройки сайта',
        subtitle: 'Управление контентом и параметрами сайта',
        sectionsTitle: 'Разделы',
        navDocuments: 'Документы',
        navNews: 'Новости',
        navNewsCategories: 'Рубрики новостей',
        news: {
          title: 'Новости сайта',
          addNew: 'Добавить новость',
          searchPlaceholder: 'Поиск по заголовку...',
          loadError: 'Не удалось загрузить новости',
          actionError: 'Не удалось выполнить действие',
          uploadError: 'Не удалось загрузить изображение',
          empty: 'Новостей пока нет',
          allStatuses: 'Все статусы',
          allCategories: 'Все рубрики',
          published: 'Опубликовано',
          draft: 'Черновик',
          featured: 'Закреплено',
          updated: 'Обновлено',
          views: 'Просмотры',
          feature: 'Закрепить',
          unfeature: 'Открепить',
          publish: 'Опубликовать',
          unpublish: 'Снять с публикации',
          publishedDone: 'Новость опубликована',
          unpublishedDone: 'Новость снята с публикации',
          edit: 'Редактировать',
          delete: 'Удалить',
          deleteTitle: 'Удалить новость',
          deleteConfirm: 'Вы уверены, что хотите удалить',
          createTitle: 'Новая новость',
          create: 'Создать',
          cancel: 'Отмена',
          createValidation: 'Укажите заголовок и адрес (slug)',
          titleRu: 'Заголовок (рус)',
          titleKk: 'Заголовок (каз)',
          titleField: 'Заголовок',
          category: 'Рубрика',
          noCategory: 'Без рубрики',
          slugLabel: 'Адрес (slug)',
          slugHint: 'Ссылка:',
          back: 'К списку',
          save: 'Сохранить',
          saved: 'Сохранено',
          history: 'История',
          historyTitle: 'История версий',
          historyEmpty: 'Версий пока нет',
          version: 'Версия',
          restore: 'Восстановить',
          restoreConfirm: 'Восстановить эту версию? Текущее содержимое будет сохранено в историю.',
          restoreDone: 'Версия восстановлена',
          preview: 'Предпросмотр',
          editMode: 'Редактор',
          unsaved: 'Есть несохранённые изменения',
          unsavedConfirm: 'Есть несохранённые изменения. Покинуть страницу?',
          emptyContent: 'Содержимое пусто',
          excerpt: 'Краткое описание',
          excerptHint: 'Короткий анонс для карточек и SEO',
          body: 'Текст статьи',
          publishSection: 'Публикация',
          metaSection: 'Параметры',
          cover: 'Обложка',
          uploadCover: 'Загрузить',
          removeCover: 'Удалить обложку',
          tags: 'Теги',
          tagsHint: 'через запятую',
          author: 'Автор',
          seoTitle: 'SEO-заголовок',
          seoDescription: 'SEO-описание',
          langRu: 'Рус',
          langKk: 'Каз',
          cat: {
            title: 'Рубрики новостей',
            addNew: 'Добавить рубрику',
            loadError: 'Не удалось загрузить рубрики',
            actionError: 'Не удалось выполнить действие',
            empty: 'Рубрик пока нет',
            postCount: 'Новостей',
            order: 'Порядок',
            createTitle: 'Новая рубрика',
            editTitle: 'Редактировать рубрику',
            titleRu: 'Название (рус)',
            titleKk: 'Название (каз)',
            key: 'Ключ',
            validation: 'Укажите название и ключ',
            save: 'Сохранить',
            cancel: 'Отмена',
            delete: 'Удалить',
            deleteTitle: 'Удалить рубрику',
            deleteConfirm: 'Удалить рубрику',
            deleteWarn: 'У {n} новостей будет снята рубрика.',
          },
        },
        docs: {
          title: 'Документы сайта',
          addNew: 'Добавить документ',
          searchPlaceholder: 'Поиск по названию или адресу...',
          loadError: 'Не удалось загрузить документы',
          actionError: 'Не удалось выполнить действие',
          empty: 'Документы не найдены',
          systemBadge: 'Системный',
          published: 'Опубликован',
          draft: 'Черновик',
          version: 'Версия',
          updated: 'Обновлён',
          edit: 'Редактировать',
          delete: 'Удалить',
          cannotDelete: 'Системный документ нельзя удалить',
          publish: 'Опубликовать',
          unpublish: 'Снять с публикации',
          createTitle: 'Новый документ',
          titleRu: 'Название (рус)',
          titleKk: 'Название (каз)',
          slugLabel: 'Адрес (slug)',
          slugHint: 'Ссылка на сайте:',
          createValidation: 'Заполните название на обоих языках и адрес',
          create: 'Создать',
          cancel: 'Отмена',
          deleteTitle: 'Удалить документ?',
          deleteConfirm: 'Вы действительно хотите удалить',
          back: 'Назад',
          save: 'Сохранить',
          saved: 'Сохранено',
          history: 'История',
          upload: 'Загрузить Word/PDF',
          preview: 'Предпросмотр',
          editMode: 'Редактор',
          unsaved: 'Есть несохранённые изменения',
          docTitle: 'Название документа',
          langRu: 'Русский',
          langKk: 'Қазақша',
          uploadReplaceConfirm: 'Текущее содержимое будет заменено загруженным документом. Продолжить?',
          uploadError: 'Не удалось обработать файл. Загрузите .docx или .pdf.',
          unsavedConfirm: 'Есть несохранённые изменения. Покинуть страницу?',
          restoreConfirm: 'Восстановить эту версию? Текущее содержимое будет сохранено в истории.',
          restoreDone: 'Версия восстановлена',
          emptyContent: 'Содержимое отсутствует',
          historyTitle: 'История версий',
          historyEmpty: 'История изменений пуста',
          restore: 'Восстановить',
        },
        editor: {
          linkPrompt: 'Введите URL ссылки',
          imagePrompt: 'Введите URL изображения',
          undo: 'Отменить',
          redo: 'Повторить',
          fontFamily: 'Шрифт',
          fontDefault: 'Шрифт',
          fontSize: 'Размер',
          sizeDefault: 'Размер',
          bold: 'Жирный',
          italic: 'Курсив',
          underline: 'Подчёркнутый',
          strike: 'Зачёркнутый',
          textColor: 'Цвет текста',
          highlight: 'Выделение',
          paragraph: 'Абзац',
          h1: 'Заголовок 1',
          h2: 'Заголовок 2',
          h3: 'Заголовок 3',
          alignLeft: 'По левому краю',
          alignCenter: 'По центру',
          alignRight: 'По правому краю',
          alignJustify: 'По ширине',
          bulletList: 'Маркированный список',
          orderedList: 'Нумерованный список',
          blockquote: 'Цитата',
          link: 'Ссылка',
          unlink: 'Убрать ссылку',
          image: 'Изображение по ссылке',
          imageUpload: 'Загрузить изображение с устройства',
          imageUploadError: 'Не удалось загрузить изображение',
          table: 'Таблица',
          horizontalRule: 'Горизонтальная линия',
          clearFormatting: 'Очистить форматирование',
          placeholder: 'Начните вводить текст документа...',
        },
      },

      // Server Status
      navServerStatus: 'Состояние сервера',
      serverStatusTitle: 'Состояние сервера',
      serverStatusDesc: 'Метрики инфраструктуры в реальном времени',
      serverStatusTabMetrics: 'Метрики',
      serverStatusTabLogs: 'Логи',
      serverStatusRefresh: 'Обновить',
      serverStatusRefreshing: 'Обновление...',
      serverStatusFetchedAt: 'Данные получены',
      serverStatusAutoRefresh: 'Авто',
      serverStatusAutoOff: 'Выкл',

      // Services section
      serverServicesTitle: 'Статус сервисов',
      serverServiceApi: 'API',
      serverServiceMongo: 'MongoDB',
      serverServiceRedis: 'Redis',
      serverServiceCelery: 'Celery',
      serverServiceOnline: 'Online',
      serverServiceOffline: 'Offline',

      // System section
      serverSystemTitle: 'Ресурсы сервера',
      serverSystemCpu: 'Нагрузка CPU',
      serverSystemRam: 'Память RAM',
      serverSystemDisk: 'Диск',
      serverSystemUptime: 'Uptime сервера',
      serverSystemApiStarted: 'API запущен',
      serverSystemCores: 'ядер',
      serverSystemUsed: 'занято',
      serverSystemFree: 'свободно',

      // MongoDB section
      serverMongoTitle: 'MongoDB',
      serverMongoConnCurrent: 'Подключений',
      serverMongoConnAvail: 'Доступно',
      serverMongoUptime: 'Uptime',
      serverMongoDbSize: 'Размер БД',
      serverMongoCollections: 'Коллекций',
      serverMongoObjects: 'Документов',
      serverMongoOps: 'Операции (всего)',

      // Redis section
      serverRedisTitle: 'Redis',
      serverRedisMemUsed: 'Память',
      serverRedisMemPeak: 'Пиковая',
      serverRedisClients: 'Клиентов',
      serverRedisOps: 'Ops/сек',
      serverRedisKeys: 'Ключей',
      serverRedisUptime: 'Uptime',

      // Celery section
      serverCeleryTitle: 'Celery / Воркер',
      serverCeleryLastRun: 'Последний запуск',
      serverCeleryStatus: 'Статус',
      serverCeleryTenders: 'Тендеров проверено',
      serverCeleryNotifs: 'Уведомлений',
      serverCelerySchedule: 'Расписание',
      serverCeleryScheduleVal: 'каждые {n} мин.',
      serverCeleryNeverRun: 'Никогда не запускался',
      serverCeleryStatusOk: 'Успешно',
      serverCeleryStatusRunning: 'Выполняется',
      serverCeleryStatusError: 'Ошибка',

      // Logs tab
      serverLogsTitle: 'Журналы сервисов',
      serverLogsApiTitle: 'Логи API',
      serverLogsWorkerTitle: 'История запусков воркера',
      serverLogsLevelAll: 'Все уровни',
      serverLogsLevelInfo: 'INFO',
      serverLogsLevelWarning: 'WARNING',
      serverLogsLevelError: 'ERROR',
      serverLogsTotalBuffered: 'записей в буфере',
      serverLogsEmpty: 'Буфер логов пуст',
      serverLogsWorkerEmpty: 'История запусков пуста',
      serverLogsColTime: 'Время',
      serverLogsColLevel: 'Уровень',
      serverLogsColLogger: 'Логгер',
      serverLogsColMessage: 'Сообщение',
      serverLogsWorkerColStart: 'Запуск',
      serverLogsWorkerColFinish: 'Завершение',
      serverLogsWorkerColStatus: 'Статус',
      serverLogsWorkerColTenders: 'Тендеров',
      serverLogsWorkerColNotifs: 'Уведомлений',
      serverLogsWorkerColErrors: 'Ошибок',

      // Extended log system
      serverLogsCopyToClipboard: 'Копировать',
      serverLogsCopied: 'Скопировано!',
      serverLogsScrollToBottom: 'Вниз',
      serverLogsServiceApi: 'API',
      serverLogsServiceMongo: 'MongoDB',
      serverLogsServiceRedis: 'Redis',
      serverLogsServiceWorker: 'Воркер',
      serverLogsLimitRows: 'строк',
      serverLogsSourceAll: 'Все источники',
      serverLogsSourceAccess: 'HTTP запросы',
      serverLogsSourceApp: 'Приложение',
      serverLogsSourceSystem: 'Система',
      serverLogsMongoTitle: 'Внутренний лог MongoDB',
      serverLogsMongoInfo: 'Последние записи из буфера памяти MongoDB',
      serverLogsMongoEmpty: 'Лог MongoDB пуст',
      serverLogsRedisTitle: 'Redis Slowlog',
      serverLogsRedisInfo: 'Запросы, превысившие порог slowlog-log-slower-than',
      serverLogsRedisEmpty: 'Slowlog пуст',
      serverLogsRedisThreshold: 'Порог: {n} — записываются команды медленнее этого значения',
      serverLogsRedisColId: '#',
      serverLogsRedisColTime: 'Время',
      serverLogsRedisColDuration: 'Длительность',
      serverLogsRedisColCommand: 'Команда',
      serverLogsWorkerDetailTitle: 'Детальные логи воркера',
      serverLogsWorkerDetailInfo: 'Ключевые события внутри задач Celery',
      serverLogsWorkerDetailEmpty: 'Нет детальных логов',
      serverCeleryStale: 'Воркер не запускался дольше расписания ({n} мин.)',
    },
  },
  kk: {
    pdfImport: {
      processing: 'PDF деректері танылуда. Аяқталғанша күте тұрыңыз.',
      busy: 'Тану сервисі қазір бос емес. Бірнеше секундтан кейін қайта жүктеңіз.',
      timeout: 'PDF өңдеу нәтижесін күту мүмкін болмады. Қайта жүктемес бұрын профиль деректерін тексеріңіз.',
      unavailable: 'PDF тану уақытша қолжетімсіз. Кейінірек қайталаңыз немесе өрістерді қолмен толтырыңыз.',
      incompleteHistory: 'Негізгі деректер сақталды. Жылдық көрсеткіштердің бір бөлігін растау мүмкін болмады: есептеуге дейін бос өрістерді тексеріп, толтырыңыз.',
      historyRequired: 'Қаржылық жоспарлау үшін алты жылдық көрсеткіштің бәрін толтырыңыз. Мәні нөл болса, 0 деп жазыңыз: бос өріс деректердің белгісіз екенін білдіреді.',
    },
    lots: {
      title: 'Лоттарды іздеу',
      subtitle: 'Қазақстан мемлекеттік сатып алуларының барлық лоттары: тауарлар, жұмыстар мен қызметтер санаттары, тапсырыс берушілер, сомалар және өңірлер бойынша ыңғайлы іздеу',
      searchPlaceholder: 'Лоттың атауы немесе сипаттамасы...',
      categoryBtn: 'БЕНС ТЖҚ санаты',
      allFilters: 'Барлық критерийлер',
      searchBtn: 'Іздеу',
      searching: 'Лоттарды іздеудеміз…',
      found: 'Табылған лоттар',
      empty: 'Сұранысыңыз бойынша лоттар табылмады. Критерийлерді өзгертіп көріңіз.',
      tooBroad: 'Сұраныс тым кең — фильтрлер қосыңыз.',
      searchFailed: 'Нәтижелерді жүктеу мүмкін болмады. Іздеуді қайталаңыз.',
      cursorExpired: 'Іздеу сеансы аяқталды. Нәтижелерді жаңарту үшін бірінші беттен бастаңыз.',
      restartSearch: 'Бірінші беттен бастау',
      retry: 'Қайталау',
      sortDegraded: 'Нәтижелер табылды. Таңдалған сұрыптау уақытша қолжетімсіз; лоттардың реті өзгеше болуы мүмкін.',
      supplierCoverage: 'Санат бойынша жеткізушілер қолжетімді қатысу тарихымен анықталады. Тізім толық болмауы мүмкін.',
      supplierPartial: 'Санат жеткізушілерінің кейбір деректері уақытша қолжетімсіз. Табылған сатып алулардың қатысушылары көрсетілген.',
      supplierSortDegraded: 'Жеткізушілер табылды. Сәйкестік бойынша сұрыптау уақытша қолжетімсіз.',
      count: {
        pending: 'Нақты саны есептелуде…',
        error: 'Санын есептеу мүмкін болмады',
        unavailable: 'Саны әзірге қолжетімсіз',
      },
      pagination: { label: 'Нәтижелер беттері', page: 'Бет' },
      sort: {
        label: 'Сұрыптау',
        newest: 'Алдымен жаңалары',
        relevance: 'Сәйкестік бойынша',
        amountDesc: 'Сома: кему бойынша',
        amountAsc: 'Сома: өсу бойынша',
      },
      filters: {
        subjectType: 'Сатып алу нысанасы',
        anySubjectType: 'Барлығы',
        subjectCategoryHint: 'Сатып алу нысанасы мен таңдалған ЕНС ТРУ санаттары бірге қолданылады.',
        subjectUnavailable: 'Сатып алу нысанасының сүзгісі уақытша қолжетімсіз. Басқа іздеу шарттары жұмыс істейді.',
        lotNumber: 'Лот нөмірі',
        annoNumber: 'Хабарландыру нөмірі',
        customerBin: 'Тапсырыс беруші БСН',
        customerName: 'Тапсырыс беруші атауы',
        customerNamePh: 'Мысалы: білім бөлімі',
        amountFrom: 'Сома, бастап ₸',
        amountTo: 'Сома, дейін ₸',
        dateFrom: 'Жаңартылған күні, бастап',
        dateTo: 'Жаңартылған күні, дейін',
        region: 'Жеткізу өңірі',
        allRegions: 'Барлық өңірлер',
        status: 'Лот мәртебесі',
        tradeMethod: 'Сатып алу тәсілі',
        anyStatus: 'Барлық мәртебелер',
        showOtherStatuses: 'Қалған мәртебелерді көрсету',
        hideOtherStatuses: 'Қалған мәртебелерді жасыру',
        anyMethod: 'Барлық тәсілдер',
        anyCategory: 'Барлық санаттар',
        reset: 'Фильтрлерді тазалау',
      },
      table: {
        lotNumber: 'Лот & Конкурс №',
        name: 'Лот атауы',
        customer: 'Тапсырыс беруші',
        count: 'Бірліктер саны / т.т.',
        amount: 'Сомасы',
        tradeMethod: 'Сатып алу тәсілі',
        status: 'Мәртебесі',
      },
      tabs: {
        general: 'Жалпы мәліметтер',
        lots: 'Лоттар',
        documents: 'Құжаттама',
        discussion: 'Талқылау',
        protocols: 'Хаттамалар',
        contracts: 'Шарттар',
        appeal: 'Апелляциялар',
        analytics: 'GLauncher аналитикасы',
      },
      card: {
        anno: 'Хабарландыру',
        count: 'Саны',
      },
      picker: {
        title: 'БЕНС ТЖҚ санаттары',
        goods: 'Тауарлар',
        works: 'Жұмыстар',
        services: 'Қызметтер',
        searchPlaceholder: 'Санатты атауы бойынша іздеу...',
        wholeSection: 'Бүкіл бөлімді таңдау',
        codesCount: 'санат',
        lotsCount: 'лот',
        allTime: 'Қосымша сүзгілерсіз, барлық уақыттағы лоттар саны',
        countedAt: 'Есептелген уақыт',
        empty: 'Санаттар табылмады',
        apply: 'Қолдану',
        clear: 'Тазалау',
        selectedLabel: 'Таңдалды',
        selectHint: 'Бірнеше санатты таңдауға болады',
        limit: 'Ең көбі 20 санат таңдалды. Басқасын қосу үшін біреуін алып тастаңыз.',
        remove: 'Санатты алып тастау',
        close: 'Қолданбай жабу',
        back: 'Артқа',
        loadFailed: 'Санаттарды жүктеу мүмкін болмады.',
      },
      detail: {
        notFound: 'Лот табылмады',
        backToSearch: 'Лоттарды іздеуге',
        onGoszakup: 'goszakup.gov.kz сайтында ашу',
        lotInfo: 'Лот туралы мәліметтер',
        lotNumber: 'Лот нөмірі',
        status: 'Лот мәртебесі',
        tradeMethod: 'Сатып алу тәсілі',
        subjectType: 'Сатып алу мәнінің түрі',
        finYear: 'Қаржы жылы',
        description: 'Сипаттамасы',
        count: 'Саны',
        amount: 'Сомасы',
        customerBin: 'Тапсырыс беруші БСН',
        enstru: 'БЕНС ТЖҚ санаты',
        updated: 'Жаңартылды',
        annoInfo: 'Хабарландыру',
        sectionsLabel: 'Лот бөлімдері',
        annoNumber: 'Хабарландыру нөмірі',
        annoName: 'Атауы',
        annoStatus: 'Хабарландыру мәртебесі',
        organizer: 'Ұйымдастырушы',
        orgBin: 'Ұйымдастырушы БСН',
        totalSum: 'Хабарландырудың жалпы сомасы',
        lotsCount: 'Лоттар саны',
        publishDate: 'Жарияланды',
        startDate: 'Өтінімдер қабылдаудың басталуы',
        endDate: 'Өтінімдер қабылдаудың аяқталуы',
        itogiDate: 'Қорытындылар',
        noAnno: 'Хабарландыру туралы мәліметтер қолжетімсіз.',
        currentLot: 'ағымдағы лот',
        noAnnoLots: 'Хабарландыру лоттары табылмады.',
        docsUnavailable: 'Құжаттарға сілтемелер біздің базаға әлі жүктелмеген. Хабарландыру мен лот құжаттарын мемлекеттік сатып алу порталынан тексеріңіз.',
        downloadDocument: 'Жүктеп алу',
        documentsPartial: 'Дереккөздегі қолжетімді сілтемелер көрсетілген. Басқа құжаттар мемлекеттік сатып алу порталында болуы мүмкін.',
        noProtocolFiles: 'Хаттама файлдарының сілтемелері әлі алынбаған. Құжаттарды мемлекеттік сатып алу порталынан тексеріңіз.',
        documentKinds: {
          results: 'Қорытындылар хаттамасы',
          discussion: 'Талқылау хаттамасы',
          opening: 'Ашу хаттамасы',
          document: 'Құжат',
        },
        discusStart: 'Талқылаудың басталуы',
        discusEnd: 'Талқылаудың аяқталуы',
        discusHint: 'Сұрақтар мен жауаптардың мәтіндері мемлекеттік сатып алу порталында қолжетімді.',
        noDiscussion: 'Бұл хабарландыру бойынша құжаттама ережелерін талқылау өткізілмеді немесе деректер қолжетімсіз.',
        noApps: 'Қатысушылардың өтінімдері әлі жарияланбаған немесе қолжетімсіз.',
        appsHint: 'Порталдың хаттамалық деректерінен осы хабарландыру бойынша қатысушылардың өтінімдері.',
        appLotUnknown: 'Хабарландыру бойынша өтінім; дәл осы лотқа қатысу жүктелген деректермен расталмаған.',
        dateApply: 'Беру күні',
        protNumber: 'Хаттама №',
        appLotPrice: 'Лот бойынша баға',
        appLotsCount: 'Өтінімдегі лоттар',
        noContracts: 'Хабарландыру бойынша шарттар әлі жасалмаған немесе қолжетімсіз.',
        noAppeals: 'Апелляциялар туралы мәліметтер мемлекеттік сатып алу порталында қолжетімді.',
        noSuppliers: 'Ықтимал жеткізушілер табылмады.',
        planInfo: 'Сатып алу жоспарының тармақтары',
        planPrice: 'Бірлік бағасы',
        planYear: 'Жыл',
        contracts: 'Хабарландыру бойынша шарттар',
        contractNumber: 'Шарт №',
        supplier: 'Жеткізуші',
        signDate: 'Қол қойылды',
        contractSum: 'Сомасы',
        analytics: 'GLauncher аналитикасы',
        analyticsUnavailable: 'Бұл лот бойынша аналитика үшін деректер жеткіліксіз.',
        medianAmount: 'Ұқсас лоттардың медианалық сомасы',
        avgAmount: 'Орташа сома',
        minMax: 'Мин – Макс ',
        sample: 'Іріктемедегі лоттар',
        similarLots: 'Ұқсас лоттар',
        uniqueParticipants: 'Бірегей қатысушылар',
        avgApps: 'Орташа өтінім саны',
        possibleSuppliers: 'Ықтимал жеткізушілер',
        possibleSuppliersHint: 'Жеткізушілер ұқсас лоттар бойынша таңдалған. Көрсеткіштер жеткізушінің бүкіл қолжетімді тарихын қамтиды: қатысулар — өтінімі немесе шарты бар бірегей конкурстар, жеңістер — шарты бар конкурстар. Барлық негізгі шарттардың сомасы жеткізуші парағындағы аналитикамен бірдей; қосымша келісімдер бөлек қосылмайды.',
        supplierSearch: 'БСН немесе компания атауы бойынша іздеу',
        showMoreSuppliers: 'Тағы көрсету',
        showLessSuppliers: '3 компанияға дейін жинау',
        suppliersPartial: 'Деректер толық болмауы мүмкін: кейбір жеткізушілер немесе көрсеткіштер әзірге қолжетімсіз.',
        suppliersError: 'Жеткізушілерді жүктеу мүмкін болмады. Қойындыны қайта ашып көріңіз.',
        participations: 'Қатысулар',
        wins: 'Жеңістер',
        wonSum: 'Шарттар сомасы',
        inRnu: 'ЖҚТ',
        analyticsDisclaimer: 'Аналитика мемлекеттік сатып алулар порталының тарихи деректеріне негізделген және анықтамалық сипатта.',
      },
    },
    suppliers: {
      title: 'Жеткізушілер',
      subtitle: 'Қазақстан мемлекеттік сатып алуларының жеткізушілер тізілімі: атауы, БСН және БЕНС ТЖҚ санаттары бойынша іздеу',
      searchPlaceholder: 'Компания атауы немесе БСН...',
      found: 'Табылған жеткізушілер',
      searching: 'Жеткізушілерді іздеудеміз…',
      empty: 'Жеткізушілер табылмады. Сұранысты өзгертіп көріңіз.',
      notFound: 'Жеткізуші табылмады',
      backToSearch: 'Жеткізушілерді іздеуге',
      table: {
        name: 'Атауы',
        bin: 'БСН',
        region: 'Өңір',
        regdate: 'Тіркелу күні',
        marks: 'Белгілері',
      },
      markSmall: 'Шағын кәсіпкерлік',
      markQvazi: 'Квазимемлекеттік сектор',
      inRnuFull: 'Жосықсыз қатысушылар тізілімінде',
      registryInfo: 'Тіркеу деректері',
      fullName: 'Толық атауы',
      iin: 'ЖСН',
      regdate: 'Тіркелу күні',
      kopf: 'Ұйымдық-құқықтық нысаны',
      krp: 'КӘӨ (кәсіпорын өлшемі)',
      oked: 'ЭҚЖЖ кодтары',
      country: 'Елі',
      roles: 'Порталдағы рөлдері',
      roleSupplier: 'Жеткізуші',
      roleCustomer: 'Тапсырыс беруші',
      roleOrganizer: 'Ұйымдастырушы',
      rnuHistory: 'Жосықсыз қатысушылар тізіліміндегі жазбалар',
      rnuOpen: 'мерзімсіз',
      contractsCount: 'Шарттар',
      contractsSum: 'Шарттар сомасы',
      applications: 'Берілген өтінімдер',
      totalParticipations: 'Қатысулар',
      totalWins: 'Жеңістер',
      historyMetricsHint: 'Бүкіл қолжетімді тарих бойынша: қатысулар — өтінімі немесе шарты бар бірегей конкурстар, жеңістер — шарты бар конкурстар. Шарттар сомасы барлық негізгі шарттарды қамтиды, қосымша келісімдер қайта қосылмайды. «Берілген өтінімдер» — конкурстар емес, жүктелген өтінім жазбаларының саны.',
      customers: 'Тапсырыс берушілер',
      topCategories: 'Негізгі сатып алу санаттары',
      topCategoriesHint: 'Жеткізуші жиі шарт жасасқан БЕНС ТЖҚ санаттары — басу санат бойынша лоттарды іздеуді ашады',
      participations: 'Берілген өтінімдер',
      applicationsTitle: 'Өтінімдер',
      applicationCountsHint: 'Тақырыптағы және «Берілген өтінімдердегі» сан — берілген өтінім жазбаларының саны. «Жеңімпаз өтінімдер» — шарты бар бірегей конкурстар; бастапқы өтінім жазбасы болмауы мүмкін. Бұл көрсеткіштер қосылмайды.',
      winningApplications: 'Жеңімпаз өтінімдер',
      winningHint: 'Осы жеткізушінің шартымен жеңісі расталған бірегей конкурстар.',
      participationsError: 'Өтінімдерді жүктеу мүмкін болмады. Қайта жүктеу үшін блокты жауып, қайта ашыңыз.',
      lotDataUnavailable: 'Лот деректері әзірге қолжетімсіз',
      lotsIncomplete: 'Лоттар құрамы толық қалпына келтірілмеген.',
      analyticsPartial: 'Кейбір талдау деректері уақытша қолжетімсіз; көрсеткіштер толық болмауы мүмкін.',
      contractsTitle: 'Шарттар',
      contractsActive: 'Қолданыстағы',
      contractsExecuted: 'Орындалған',
      contractYear: 'Жыл',
      allYears: 'Барлық жылдар',
      contractNumber: 'Шарт нөмірі',
      contractAmount: 'Шарт сомасы',
      contractDate: 'Жасалған күні',
      noContracts: 'Таңдалған шарттарға сәйкес шарттар табылмады.',
      contractsError: 'Шарттарды жүктеу мүмкін болмады. Қайта жүктеу үшін блокты жауып, қайта ашыңыз.',
      contractsPartial: 'Шарт деректері толық болмауы мүмкін. Мәртебесі белгісіз шарттар бұл қойындыларға енгізілмеген.',
      collapse: 'Жию',
      noParticipations: 'Жеткізушінің өтінімдері табылмады.',
      partAnno: 'Хабарландыру',
      partDate: 'Беру күні',
      partLots: 'Лоттар',
    },
    news: {
      title: 'Жаңалықтар',
      subtitle: 'Мемлекеттік сатып алулар бойынша қызметтік жаңалықтар, жаңартулар және пайдалы ресурстар',
      allCategories: 'Барлығы',
      searchPlaceholder: 'Іздеу...',
      empty: 'Әзірге жаңалықтар жоқ',
      featured: 'Басты',
      min: 'мин',
      prev: 'Артқа',
      next: 'Әрі қарай',
      notFoundTitle: 'Жаңалық табылмады',
      notFoundText: 'Материал жойылған немесе әлі жарияланбаған болуы мүмкін.',
      backToList: 'Барлық жаңалықтарға',
      latestTitle: 'Соңғы жаңалықтар',
      sectionTag: 'Жаңалықтар',
      sectionTitle: 'Жаңалықтар мен жаңартулар',
      sectionAll: 'Барлық жаңалықтар',
    },
    nav: {
      main: 'Басты бет',
      lotsSearch: 'Лоттарды іздеу',
      lots: 'Лоттарды іздеу',
      suppliers: 'Жеткізушілер',
      tracker: 'Лоттарды бақылау',
      calculator: 'Қатысуға рұқсатты қаржылық талдау',
      services: 'Қызметтер',
      information: 'Ақпарат',
      openMenu: 'Мәзірді ашу',
      closeMenu: 'Мәзірді жабу',
      switchLanguage: 'Тілді орыс тіліне ауыстыру',
      financialPlanning: 'Қаржылық жоспарлау',
      experience: 'Тәжірибені есептеу',
      adminPanel: 'Әкімші панелі',
      contacts: 'Байланыстар',
      questions: 'Сұрақтар',
      about: 'Біз туралы',
      news: 'Жаңалықтар',
      profile: 'Жеке кабинет',
      goToProfile: 'Кабинетке өту',
      logout: 'Шығу',
      login: 'Кіру',
      balance: 'Баланс',
      balancePfu: 'ҚТК есептеулер',
      balanceVip: 'VIP есептеулер',
      balanceSlots: 'Трекер слоттары',
      balancePlanning: 'Жоспарлау есептеулері',
      balanceTier: 'Тир есептеулері',
      balanceFill: 'Толтыру',
      plans: 'Тарифтер',
      subscription: 'Жазылым',
      subActive: 'Белсенді',
      subCancelled: 'Тоқтатылған',
      noSubscription: 'Тариф жоқ',
      upgradePlan: 'Тарифті жақсарту',
      viewPlans: 'Тарифтерді көру',
    },
    auth: {
      googleAuthTitle: 'Google Авторизация...',
      googleAuthDesc: 'Күтіңіз, біз сіздің аккаунтыңызды баптап жатырмыз',
      googleSetupTitle: 'Тіркелуді аяқтау',
      googleSetupDesc: 'Google арқылы авторизацияны аяқтау үшін жетіспейтін деректерді толтырып, шарттарды қабылдаңыз.',
      finishBtn: 'Аяқтау',
      loginTitle: 'Аккаунтқа кіру',
      or: 'немесе',
      registerNewAccount: 'жаңа аккаунт тіркеңіз',
      emailLabel: 'Email мекенжайы',
      passwordLabel: 'Құпия сөз',
      rememberMe: 'Мені есте сақтау',
      forgotPassword: 'Құпия сөзді ұмыттыңыз ба?',
      loggingIn: 'Кіру...',
      loginBtn: 'Кіру',
      loginVia: 'Арқылы кіру',
      redirecting: 'Қайта бағыттау...',
      registerTitle: 'Аккаунт жасау',
      alreadyHaveAccount: 'Аккаунтыңыз бар ма?',
      loginToSystem: 'Жүйеге кіріңіз',
      firstNameLabel: 'Аты',
      lastNameLabel: 'Тегі',
      phoneLabel: 'Телефон',
      confirmPasswordLabel: 'Құпия сөзді растаңыз',
      registering: 'Тіркелу...',
      registerBtn: 'Тіркелу',
      registerVia: 'Арқылы тіркелу',
      registerTermsHint1: 'Сайтта тіркелу арқылы мен ',
      registerTermsOffer: 'Жария офертаның',
      registerTermsHint2: ', ',
      registerTermsPrivacy: 'Құпиялық саясатының',
      registerTermsHint3: ' шарттарын қабылдаймын және дербес деректерді өңдеуге келісім беремін.',
      termsMustBeAccepted: 'Келісім қажет',
      termsNeedToAcceptError: 'Тіркелу үшін шарттар мен саясатты қабылдау қажет',
      phoneRequiredError: 'Дұрыс телефон нөмірін енгізіңіз',
      legalWarning: 'Деректерді автоматты түрде жинауға, сканерлеуге, сұрауларды таңдауға, шектеулерді айналып өтуге және ақпараттық жүйеге заңсыз қол жеткізудің өзге де әрекеттеріне тыйым салынады және Қазақстан Республикасы Қылмыстық кодексінің 205 және 208-баптарына сәйкес жауаптылыққа әкеп соғуы мүмкін.',
      forgotPasswordTitle: 'Құпия сөзді қалпына келтіру',
      forgotPasswordDesc: 'Email-ді енгізіңіз, біз құпия сөзді қалпына келтіру кодын жібереміз.',
      sendCodeBtn: 'Кодты жіберу',
      sendingCode: 'Жіберілуде...',
      resetPasswordTitle: 'Құпия сөзді жаңарту',
      resetPasswordDesc: 'Хаттағы кодты және жаңа құпия сөзді енгізіңіз.',
      codeLabel: 'Тексеру коды',
      newPasswordLabel: 'Жаңа құпия сөз',
      resetBtn: 'Құпия сөзді жаңарту',
      resetting: 'Жаңартылуда...',
      backToLogin: 'Кіру бетіне оралу',
      codeSentMsg: 'Код сіздің email-ге жіберілді!',
      passwordResetMsg: 'Құпия сөз сәтті өзгертілді. Жүйеге кіре аласыз.',
      passwordRequirements: 'Құпия сөз кем дегенде 8 таңбадан тұруы, ішінде 1 бас әріп және 1 сан болуы тиіс.'
    },
    errors: {
      default: 'Белгісіз қате пайда болды',
      network: 'Желі қатесі',
      invalid_credentials: 'Логин немесе құпия сөз қате',
      invalid_code: 'Тексеру коды қате',
      user_exists: 'Бұл email-мен пайдаланушы тіркелген',
      passwords_mismatch: 'Құпия сөздер сәйкес келмейді',
      cooldown: 'Қайта жібермес бұрын күте тұрыңыз',
      too_many_requests: 'Тым көп сұрау. Кейінірек қайталаңыз.',
      unauthorized: 'Сеанс аяқталды. Қайта кіріңіз.',
      google_auth_failed: 'Google арқылы авторизациялау қатесі. Қайта көріңіз.',
      google_client_id_missing: 'Google Client ID бапталмаған. Конфигурацияны тексеріңіз.',
      passwordTooShort: 'Құпиясөз кем дегенде 8 таңбадан тұруы керек',
      user_not_found: 'Пайдаланушы табылмады',
      google_user_password_reset: 'Google арқылы тіркелген аккаунттың құпия сөзін қалпына келтіру мүмкін емес.',
    },
    lang: {
      switch: 'РУ',
    },
    contacts: {
      title: 'Бізбен байланысыңыз',
      subtitle: 'Барлық сұрақтарыңыз бойынша көмектесуге әрқашан қуаныштымыз.',
      address: 'Мекен-жай',
      addressText: 'Алматы қ., Таугуль даңғылы, 52Б',
      phone: 'Телефон',
      phoneText: '+7 707 329 1065',
      email: 'Email',
      emailText: 'support@glauncher.kz',
      formTitle: 'Кері байланыс формасы',
      formName: 'Атыңыз',
      formNamePlaceholder: 'Атыңыз',
      formEmail: 'Email',
      formEmailPlaceholder: 'ivan@example.com',
      formMessage: 'Хабарлама',
      formMessagePlaceholder: 'Сұрағыңызды сипаттаңыз...',
      formSubmit: 'Жіберу',
      formSubmitting: 'Жіберілуде...',
      formSuccess: 'Хабарлама сәтті жіберілді! Жақын арада сізбен хабарласамыз.',
      formErrName: 'Ат 2-ден 100 символға дейін болуы тиіс',
      formErrEmail: 'Дұрыс email-мекенжайын көрсетіңіз',
      formErrMessage: 'Хабарлама 10-нан 5000 символға дейін болуы тиіс',
      formErrCaptcha: 'reCAPTCHA токенін алу сәтсіз аяқталды. Қайталаңыз.',
      formErrBot: 'Қорғау жүйесі сұранысты қабылдамады. Кейінірек қайталаңыз.',
      formErrNetwork: 'Желі қатесі. Байланысты тексеріп, қайталаңыз.',
      captchaDisclaimer: 'Бұл сайт reCAPTCHA арқылы қорғалған. Қолданылады',
      captchaPrivacy: 'Күпіялылық саясаты',
      captchaAnd: 'және',
      captchaTerms: 'Пайдалану шарттары',
      captchaGoogle: 'Google.',
    },
    questions: {
      title: 'Жиі қойылатын сұрақтар (ЖҚС)',
      q1: 'Қатысуға рұқсатты қаржылық талдау қалай жұмыс істейді?',
      a1: 'Жүйе сатып алу сомасы мен санатын ескере отырып, енгізілген табыс, салық және еңбекақы қоры бойынша ҚТК балын есептейді. Ең жоғары баллдан төмен нәтиже өздігінен қатысуға рұқсат берілмейтінін білдірмейді.',
      q2: 'Лотар мәртебесі қаншалықты жиі жаңартылады?',
      a2: 'Әрқашан ең өзекті ақпаратқа қол жеткізуіңіз үшін мәртебелер автоматты түрде жаңартылады.',
      q3: 'Қолданбада компания деректерін сақтау қауіпсіз бе?',
      a3: 'Барлық деректер тек сіздің құрылғыңызда (Local Storage) жергілікті түрде сақталып, толық құпиялылықты қамтамасыз етеді.',
    },
    about: {
      title: 'G-Launcher платформасы туралы',
      subtitle: 'Мемлекеттік сатып алу саласындағы сенімді аналитикалық серіктесіңіз.',
      desc1: 'Біздің платформа бизнес үшін тендерлерге қатысу процесін жеңілдету мақсатында жасалған. Біз лоттарды бақылауды, хабарламаларды және рұқсатты алдын ала талдауды ресми порталдар стиліндегі бір ыңғайлы интерфейсте біріктіреміз.',
      desc2: 'Тексеру алгоритмдеріміздің көмегімен сіз жеңіске жету мүмкіндіктеріңізді уақытылы бағалай аласыз және өтінімдердің қабылданбау қаупін азайта аласыз.',
      missionTitle: 'Біздің миссиямыз',
      missionText: 'Мемлекеттік сатып алу процестерін Қазақстан Республикасының әрбір кәсіпкері үшін барынша ашық, технологиялық және қолжетімді ету.',
      partnersTitle: 'Бізбен жұмыс істейтін компаниялар',
    },
    landing: {
      title: 'Мемлекеттік сатып алу қатысушыларына арналған платформа',
      subtitle: 'ЕНС ТРУ санаттары бойынша лоттарды іздеу, жаңа сәйкестіктерге жазылу, таңдалған сатып алуларды бақылау және қаржылық есептеулер.',
      featuresTitle: 'Сатып алулармен жұмыс істеу құралдары',
      feat1Desc: 'Таңдалған сатып алуды бақылап, мәртебе өзгерісі мен талқылау хаттамасының жариялануы туралы Telegram хабарламаларын алыңыз.',
    },
    tracker: {
      title: 'Лоттарды бақылау',
      newNotif: 'Жаңа хабарлар',
      searchPlaceholder: 'Лот нөмірі немесе атауы бойынша іздеу...',
      filters: 'Сүзгілер',
      tabTenders: 'Бақыланатын лоттар',
      tabNotif: 'Хабарлар',
      colNumName: 'Хабарландыру нөмірі және атауы',
      colStatus: 'Мәртебесі',
      colProtocol: 'Талқылау хаттамасы',
      emptyNotif: 'Жаңа хабарлар жоқ',
      emptyNotifDesc: 'Сіз барлық жүйелік хабарларды оқыдыңыз.',
      addTrackTender: 'Қосу',
      modalAddTitle: 'Лот қосу',
      modalAddDesc: 'Бақыланатын лоттарға қосу үшін хабарландыру нөмірін енгізіңіз (мысалы: 17005447-1).',
      modalAddLabel: 'Хабарландыру нөмірі',
      modalAddBtn: 'Бақыланатын лоттарға қосу',
      modalCancelBtn: 'Бас тарту',
      modalConfirmHint: 'Хабарландыру нөмірі дұрыс енгізілгенін тексеріңіз. Қосқаннан кейін трекердің бір слоты пайдаланылады.',
      modalConfirmAddBtn: 'Қосу',
      modalAdding: 'Қосылуда...',
      searchLabel: 'Іздеу',
      dateFilterTitle: 'Талқылауды жариялау күні',
      dateFilterFrom: 'Бастап',
      dateFilterTo: 'Дейін',
      colActions: 'Әрекеттер',
      delete: 'Жою',
      deleting: 'Жойылуда...',
      deleteErrorNotFound: 'Лот табылмады',
      deleteErrorFormat: 'Лот ID форматы қате',
      deleteErrorGeneric: 'Лотты жою қатесі',
      modalDeleteTitle: 'Лотты жою',
      modalDeleteDesc: 'Сіз {numberAnno} лотын бақыланатындардан жойғыңыз келетініне сенімдісіз бе? Бұл әрекетті болдырмау мүмкін емес.',
      modalDeleteBtnConfirm: 'Жою',
      modalDeleteBtnCancel: 'Болдырмау',
      noTelegramTitle: 'Telegram тіркелмеген',
      noTelegramDesc: 'Трекерге лоттарды қосу үшін Telegram аккаунтын байланыстыру қажет. Ботымыз арқылы лот мәртебелері туралы хабарлар аласыз.',
      noTelegramBtn: 'Telegram байланыстыру',
      noTelegramLinking: 'Ботты ашу...',
      noTelegramLinkError: 'Сілтемені алу сәтсіз аяқталды. Кейінірек қайталаңыз.',
      tabHistory: 'Тарих',
      historyContest: 'Конкурс нөмірі',
      historyDate: 'Күні',
      historyStatus: 'Мәртебесі',
      historyLastChecked: 'Соңғы тексеру',
      historyLoading: 'Тарих жүктелуде...',
      historyEmpty: 'Бақылау тарихы бос',
      error402: 'Слот лимиті таусылды.',
      error400: 'Бұл конкурс қазірдің өзінде бақылануда.',
      error404: 'Конкурс Госзакупок базасында табылмады.',
      buyLink: 'Слоттарды сатып алу',
      pagePrev: '← Артқа',
      pageNext: 'Келесі →',
      pageOf: '/',
      notifColAnno: 'Хабарландыру нөмірі',
      notifColPlatform: 'Платформа',
      notifColDate: 'Күні',
      notifColTime: 'Уақыт',
      notifColRecipient: 'Алушы',
      notifEmpty: 'Хабарландырулар әлі',
      notifEmptyDesc: 'Бот мәртебе өзгеріс туралы хабарландыру жібергенде, ол осында көрінеді.',
      notifModalTitle: 'Хабарландыру мәліметтері',
      notifModalClose: 'Жабу',
      notifModalAnno: 'Хабарландыру нөмірі',
      notifModalPlatform: 'Платформа',
      notifModalDate: 'Жіберу күні',
      notifModalTime: 'Жіберу уақыты',
      notifModalRecipient: 'Алушы',
      notifModalStatus: 'Жеткізу мәртебесі',
      notifModalStatusVal: 'Жеткізілді',
      notifLoading: 'Хабарландырулар жүктелуде...',
      emptyTitle: 'Бақыланатын лоттар жоқ',
      emptyDesc: 'Өзгерістерді және хаттамаларды бақылау үшін хабарландыру нөмірін қосыңыз.',
      searchNoResults: 'Ештеңе табылмады',
      searchNoResultsDesc: 'Басқа хабарландыру нөмірін немесе атауын енгізіп көріңіз.',
      searchClear: 'Іздеуді тазалау',
    },
    billing: {
      tabTitle: 'Қолжетімділік пен қызметтер',
      balanceTitle: 'Сіздің лимиттеріңіз',
      pfuLeft: 'ҚТК есептеулер',
      vipLeft: 'VIP-есептеулер',
      slotsLeft: 'Белсенді трекер слоттары',
      planningLeft: 'Жоспарлау есептеулері',
      tierLeft: 'Тир талаптары есептеулері',
      addTitle: 'Лимиттерді сатып алу',
      priceLoading: 'Бағалар жүктелуде...',
      pfuItem: 'ҚТК есептеу',
      vipItem: 'VIP-есептеу (макс. шарт)',
      slotItem: 'Трекер слоты',
      planningItem: 'Қаржылық жоспарлау есептеуі',
      tierItem: 'Тир талаптары есептеуі',
      experienceItem: 'Тәжірибені есептеу',
      priceNotConfigured: 'Жеке сатып алу әзірге қолжетімсіз',
      experienceDetails: 'Тәжірибе есебін ашу',
      unknownItem: 'Белгісіз позиция',
      totalLabel: 'Жиыны',
      buyBtn: 'Балансты толтыру',
      buying: 'Өңделуде...',
      buySuccess: '✓ Лимиттер сәтті есептелді!',
      buyError: 'Төлем қатесі. Кейінірек қайталаңыз.',
      pieces: 'дана.',
      discountBanner: '«{plan}» тарифі бойынша жеңілдік төмендегі бағаларға қолданылды',
      youSave: 'Үнем {amount} ₸',
    },
    plans: {
      heroTag: 'Тарифтік жоспарлар',
      heroTitle: 'Өз тарифіңізді таңдаңыз',
      heroSubtitle: 'Платформа қызметтерінде 60%-ға дейін үнемдеңіз. Жазылымды қосып, есептеулерді, трекер слоттарын және жоспарлауды ай сайын тұрақты бағамен алыңыз.',
      perMonth: 'ай',
      popular: 'Танымал',
      valueLabel: 'Құндылығы:',
      savings: 'үнем',
      subscribe: 'Қосу',
      switchPlan: 'Тарифті ауыстыру',
      currentPlan: 'Ағымдағы тариф',
      currentBannerTitle: 'Белсенді тарифіңіз:',
      currentBannerHint: 'Жазылымды жеке кабинетте басқаруға болады',
      manage: 'Басқару',
      loadError: 'Тарифтерді жүктеу мүмкін болмады',
      retry: 'Қайталау',
      empty: 'Тарифтер әзірге қолжетімсіз',
      reassure1Title: 'Кез келген уақытта тоқтату',
      reassure1Desc: 'Жазылымды кез келген уақытта тоқтатыңыз — ол төленген кезең соңына дейін белсенді болады.',
      reassure2Title: 'Дереу есептеу',
      reassure2Desc: 'Пакет қызметтері тариф қосылған соң бірден балансқа есептеледі.',
      reassure3Title: 'Қалғанына жеңілдіктер',
      reassure3Desc: 'Пакетке кірмейтін қызметтерге бір реттік сатып алуда жеке жеңілдік қолданылады.',
      confirmTitle: 'Тарифті қосу керек пе?',
      confirmBody: 'Сіз «{plan}» тарифін айына {price} ₸ бағамен қосасыз. Қызметтер бірден есептеледі.',
      confirmSwitchTitle: 'Тарифті ауыстыру керек пе?',
      confirmSwitchBody: 'Сіз «{plan}» тарифіне айына {price} ₸ бағамен ауысасыз. Жаңа тариф дереу күшіне енеді.',
      confirmTestNote: 'Сіз Halyk Bank-тың қорғалған төлем бетіне бағытталасыз.',
      saveCardLabel: 'Жазылымды автожаңарту үшін картаны сақтау',
      saveCardHint: 'Карта деректері тек Halyk Bank-та сақталады. Картаны профильде кез келген уақытта жоюға болады.',
      cancel: 'Бас тарту',
      confirmBtn: 'Қосу',
      processing: 'Өңделуде...',
      subscribeSuccess: '✓ Жазылым сәтті рәсімделді!',
      subscribeError: 'Жазылымды рәсімдеу мүмкін болмады. Кейінірек қайталаңыз.',
      methodCard: 'Картамен',
      methodQr: 'Halyk QR',
      qrTitle: 'Halyk QR арқылы төлеу',
      qrSubtitle: 'Homebank немесе басқа банк қосымшасында QR-кодты сканерлеңіз.',
      qrWaiting: 'Төлемнің расталуын күтудеміз...',
      qrOpenHomebank: 'Homebank-те ашу',
      qrOpenBankApp: 'Банк қосымшасында ашу',
      qrFailed: 'QR арқылы төлем аяқталмады. Қайта көріңіз.',
      // ── Anchor nav ──
      navSubscriptions: 'Жазылымдар',
      navServices: 'Бір реттік қызметтер',
      navTable: 'Баға тізімі',
      showTable: 'Қызметтердің толық тізімін көрсету',
      hideTable: 'Жасыру',
      // ── Guest CTA ──
      loginToSubscribe: 'Кіру және қосу',
      loginToBuy: 'Кіру және сатып алу',
      guestNote: 'Сатып алу үшін аккаунт қажет — кіру бір минуттан аз уақыт алады.',
      // ── Single services section ──
      servicesTag: 'Бір реттік қызметтер',
      servicesTitle: 'Жеке қызметтер',
      servicesSubtitle: 'Жазылымға дайын емессіз бе? Тек қазір қажет қызметтерге ғана төлеңіз. Бір реттік төлем, автоматты ұзартусыз.',
      unitCalc: '1 есептеу үшін',
      unitSlot: '1 слот үшін',
      unitMonth: 'айына',
      buy: 'Сатып алу',
      selected: 'Таңдалды',
      cartTitle: 'Төлемге жиыны',
      buyNow: 'Төлеу',
      buyProcessing: 'Өңделуде...',
      buySuccess: '✓ Қызметтер балансқа есептелді!',
      buyError: 'Сатып алуды рәсімдеу мүмкін болмады. Кейінірек қайталаңыз.',
      // ── Price table ──
      tableTag: 'Баға тізімі',
      tableTitle: 'Қызметтердің толық тізімі және құны',
      tableSubtitle: 'Барлық бағалар теңгемен (₸) көрсетілген. Оператор — «ПИР-Kazakhstan» ЖШС.',
      colService: 'Қызмет атауы',
      colUnit: 'Бірлік',
      colPrice: 'Құны',
      colDesc: 'Сипаттамасы',
      tableSubsGroup: 'Жазылымдар',
      tableServicesGroup: 'Бір реттік қызметтер',
      // ── Legal block ──
      legalTitle: 'Орындықтық ақпарат',
      legalOperator: 'Платформа операторы — «ПИР-Kazakhstan» ЖШС, БСН 160740018940, Қазақстан Республикасы, Алматы қ., Таугүл к-сі 52Б.',
      legalCurrency: 'Барлық есеп айырысу теңгемен (₸, KZT) жүргізіледі. Төлем банктің қорғалған төлем бетінде қабылданады: VISA, Mastercard, 3D-Secure.',
      legalDocs: 'Төлемді рәсімдеу арқылы сіз келесі құжаттардың шарттарын қабылдайсыз:',
      legalOffer: 'Жария оферта',
      legalPrivacy: 'Құпиялылық саясаты',
      legalRefund: 'Қайтару және болдырмау',
      legalSecurity: 'Төлем қауіпсіздігі',
      // ── Service descriptions ──
      svc: {
        pfuName: 'ҚТК есептеу',
        pfuDesc: 'Нақты конкурсқа қатысу үшін компанияңыздың қаржылық орнықтылық (ҚТК) критерийлеріне сәйкестігін тексеру. Бір есептеу — бір лот бойынша талдау.',
        vipName: 'VIP-есептеу (максималды сома)',
        vipDesc: 'Компания қаржылық орнықтылық көрсеткіштері бойынша қатыса алатын сатып алудың максималды сомасын кеңейтілген есептеу. Бір есептеу — бір сұраныс бойынша.',
        trackerName: 'Трекер слоты',
        trackerDesc: 'Бір лотты күй өзгерісі, хаттамалар мен қорытындылар жарияланымы туралы автоматты хабарламалармен бақылауға қою. Бір слот — бір бақыланатын лот.',
        planningName: 'Қаржылық жоспарлау есептеуі',
        planningDesc: 'Қатысудың қаржылық үлгісін есептеу: таңдалған сатып алу бойынша шығындарды, аванстарды және ақша ағынын жоспарлау. Бір есептеу — бір қаржылық үлгі.',
        tierName: 'Тир талаптары есептеуі',
        experienceName: 'Тәжірибені есептеу',
        experienceDesc: 'БСН бойынша компания тәжірибесі: ҚМЖ, жобалау және техникалық қадағалау, нысандар бойынша түсіндірмесімен. Бір операция барлық қолдау көрсетілетін бағыттарды қамтиды.',
        tierDesc: 'Таңдалған сатып алу үшін қатысушының тирлер (санаттар) бойынша талаптары мен шектеулерін анықтау. Бір есептеу — бір сұраныс бойынша.',
      },
    },
    payment: {
      checkingTitle: 'Төлем тексерілуде...',
      fulfillingTitle: 'Төлем расталды',
      fulfillingBody: 'Қолжетімділік беру әлі өңделуде. Қайта төлеудің қажеті жоқ.',
      fulfillingLater: 'Қолжетімділік беру көбірек уақыт алуда. Жеке кабинетті сәл кейінірек тексеріңіз. Қайта төлеудің қажеті жоқ.',
      checkingBody: 'Күте тұрыңыз — біз Halyk Bank-тағы төлем мәртебесін нақтылап жатырмыз.',
      successTitle: 'Төлем сәтті өтті!',
      successBody: 'Қызметтер балансыңызға есептелді. Сатып алғаныңыз үшін рахмет.',
      goProfile: 'Жеке кабинетке',
      goPlans: 'Тарифтер мен қызметтерге',
      failedTitle: 'Төлем өтпеді',
      failedBody: 'Төлем аяқталмады немесе банк қабылдамады. Қайта көріңіз немесе басқа төлем әдісін таңдаңыз.',
      pendingTitle: 'Төлем өңделуде',
      pendingBody: 'Банк әлі төлемді растаған жоқ. Бұл біраз уақыт алуы мүмкін — мәртебені жеке кабинетте кейінірек тексеріңіз.',
    },
    subscription: {
      blockTitle: 'Менің жазылымым',
      statusActive: 'Белсенді',
      statusCancelled: 'Тоқтатылған',
      perMonth: 'ай',
      nextBilling: 'Келесі есептен шығару',
      cancelledUntil: 'Жазылым тоқтатылды. Тариф {date} дейін белсенді, содан кейін есептен шығару тоқтайды.',
      archivedNote: 'Бұл тариф жаңа клиенттерге ұсынылмайды, бірақ сіз үшін жұмысын жалғастырады. Өзекті тарифке ауысуды ұсынамыз.',
      changePlan: 'Тарифті ауыстыру',
      cancelBtn: 'Жазылымды тоқтату',
      resumeBtn: 'Жазылымды жалғастыру',
      noPlanTitle: 'Сізде белсенді тариф жоқ',
      noPlanDesc: 'Жазылымды қосып, платформа қызметтерінде 60%-ға дейін үнемдеңіз.',
      choosePlan: 'Тариф таңдау',
      cancelSuccess: 'Жазылым тоқтатылды. Тариф кезең соңына дейін белсенді.',
      resumeSuccess: 'Жазылым жалғастырылды!',
      actionError: 'Әрекетті орындау мүмкін болмады. Кейінірек қайталаңыз.',
      cancelConfirmTitle: 'Жазылымды тоқтату керек пе?',
      cancelConfirmBody: 'Жазылым {date} дейін белсенді болады. Осы күннен кейін автожаңарту мен есептеу тоқтайды.',
      keepBtn: 'Қалдыру',
      confirmCancelBtn: 'Иә, тоқтату',
      autoRenewOn: 'Автожаңарту қосылған — төлем сақталған картадан автоматты түрде алынады',
      autoRenewOff: 'Автожаңарту өшірулі — кезең аяқталғанда жазылым аяқталады (сақталған карта жоқ)',
      cardsTitle: 'Сақталған карталар',
      cardsHint: 'Карта жазылымды автожаңарту үшін қолданылады. Деректер тек Halyk Bank-та сақталады — бізде тек қорғалған токен.',
      cardsEmpty: 'Сақталған карталар жоқ. Карта жазылымды төлегенде «Картаны сақтау» белгісі қойылса сақталады.',
      cardDeleteBtn: 'Жою',
      cardDeleteConfirm: 'Картаны жою керек пе? Жазылымды автожаңарту тоқтайды.',
      cardDeleted: 'Карта жойылды',
      cardDeleteError: 'Картаны жою мүмкін болмады. Кейінірек қайталаңыз.',
    },
    calc: {
      title: 'Қатысуға рұқсатты қаржылық талдау',
      subtitle: 'Таңдалған сатып алу сомасы үшін компанияның ҚТК балын есептеңіз',
      tabAnalysis: 'Конкурсты талдау',
      tabHistory: 'Тарих',
      historyEmpty: 'Талдау тарихы бос',
      historyEmptyDesc: 'Алғашқы талдауды жүргізіңіз, ол осында шығады',
      historyDate: 'Күні',
      historyCategory: 'Санат',
      historyAmount: 'Сатып алу сомасы',
      historyType: 'Түрі',
      historyStatus: 'ҚТК',
      historyVipLabel: '👑 VIP Потенциал',
      historyPass: 'Ең жоғары балл',
      historyFail: 'Ең жоғары баллға жетпеген',
      historyDetailTitle: 'Есептеу мәліметтері',
      historyDetailClose: 'Жабу',
      historyPrev: '← Артқа',
      historyNext: 'Келесі →',
      historyPageOf: '/',
      historyLoading: 'Тарих жүктелуде...',
      limitOut: 'Есептеулер таусылды.',
      limitBuyLink: 'Баланс толтыру',
      error402: 'Лимит таусылды. Жеке кабинетте толтырыңыз.',
      limitPfu: 'Қолжетімді ҚТК есептеулер',
      limitVip: 'Қолжетімді VIP-есептеулер',
      useCompanyBtn: 'Компания деректерімді пайдалану',
      useCompanyApplied: '✓ Компания деректері қолданылды',
      categoryLabel: 'Сатып алу категориясы',
      categoryPlaceholder: 'Категорияны таңдаңыз...',
      categoryLoading: 'Категориялар жүктелуде...',
      amountLabel: 'Сатып алу сомасы',
      fieldIncome: '3 жылдағы табыс (₸)',
      fieldTaxes: '3 жылдағы салықтар (₸)',
      fieldPfot: '3 жылдағы ЕҚТ (₸)',
      btnAnalyze: 'Конкурс талдауын жүргізу',
      confirmTitle: 'Талдауды іске қосуды растаңыз',
      confirmDesc: 'Қаржылық деректер мен сатып алу сомасы дұрыс енгізілгенін тексеріңіз. Іске қосқаннан кейін балансыңыздан бір есептеу шығарылады.',
      confirmBtn: 'Иә, іске қосу',
      confirmCancel: 'Бас тарту',
      confirmVipTitle: 'VIP-есептеуді растаңыз',
      confirmVipDesc: 'Компанияның қаржылық деректері дұрыс енгізілгенін тексеріңіз. Балансыңыздан бір VIP-есептеу шығарылады.',
      analyzing: 'Талдануда...',
      vipTitle: 'Компанияның максималды потенциалы',
      vipDesc: 'Табыс пен еңбекақы қоры бойынша сатып алу сомасын бағалаймыз; салық көрсеткіші бөлек тексеріледі',
      vipActivate: 'Максималды потенциалды білу',
      vipDeactivate: 'Сатып алу калькуляторына өту',
      vipBtn: 'ҚТК бойынша әлеуетті есептеу',
      vipCalculating: 'Есептелуде...',
      resultPass: 'Компания ең жоғары балл жинаған',
      resultFail: 'Компания ең жоғары балл жинамаған',
      resultScore: 'Қорытынды балл',
      resultRequired: 'ең жоғары балл',
      resultExplanation: 'Балл компанияның қаржылық көрсеткіштерін сипаттайды және сатып алуға қатысуға рұқсатты өздігінен анықтамайды.',
      resultPd: 'ПД — Табыс көрсеткіші',
      resultPun: 'ПУН — Төленген салықтар',
      resultPfot: 'ПФОТ — Еңбек қоры',
      resultAmountMrp: 'МЕК-тегі сатып алу сомасы',
      resultTierMax: 'Тирдің жоғарғы шегі',
      vipResultTitle: 'Сатып алудың есептік сомасы',
      vipWarning: 'ПУН бойынша ескерту',
      vipPunExplanation: 'ПУН көрсеткіші ({actual}) таңдалған тирдегі ең жоғары баллға қажетті мәннен ({target}) төмен. ПУН сатып алу сомасына тәуелді емес, сондықтан қорытынды ҚТК балы ең жоғары баллдан төмен болады.',
      vipPunExplanationFallback: 'ПУН көрсеткіші таңдалған тирдегі ең жоғары баллға қажетті мәннен төмен. ПУН сатып алу сомасына тәуелді емес, сондықтан қорытынды ҚТК балы ең жоғары баллдан төмен болады.',
      noCompanyTitle: 'Компания профилі толтырылмаған',
      noCompanyDesc: 'Талдау үшін компанияның қаржылық деректері қажет. Оларды қолмен енгізіңіз немесе Госзакупоктан PDF-үзінді жүктеңіз.',
      noCompanyClose: 'Жабу',
      noCompanySave: 'Қолдану және жүргізу',
      noCompanySaving: 'Сақталуда...',
      pdfLabel: 'PDF-тен жылдам импорт',
      pdfDrop: 'Госзакупоктың PDF-үзіндісін апарыңыз немесе файл таңдаңыз',
      pdfHint: 'goszakup.gov.kz профиль бетіндегі ҚТК үзіндісі • макс. 5 МБ',
      pdfParsing: '✨ GLauncher магиясы: деректер алынуда...',
      pdfSuccess: 'Деректер сәтті алынды!',
      pdfError400: 'Қате файл форматы немесе > 5 МБ',
      pdfError422: 'Деректер табылмады. Дұрыс PDF-ті жүктеңіз',
      pdfErrorDefault: 'Файлды өңдеу кезінде қате шықты',
      error404: 'Категория табылмады',
      error422: 'Деректерді тексеріңіз (табыс 0-ден көп болуы тиіс)',
      error503: 'Сервердегі МЕК баптаулары жоқ. Қолдауға хабарласыңыз.',
      errorDefault: 'Қате шықты. Кейінірек қайталаңыз.',
    },
    profile: {
      passwordTitle: 'Құпия сөзді өзгерту',
      googleAuthNotice: 'Пайдаланушы Google арқылы кірді',
      oldPasswordLabel: 'Ескі құпия сөз',
      newPasswordLabel: 'Жаңа құпия сөз',
      changePasswordBtn: 'Құпия сөзді өзгерту',
      codeWarning: 'Құпия сөзді өзгертуді аяқтау үшін хаттан код пен жаңа құпия сөзді енгізіңіз.',
      updatePasswordBtn: 'Құпия сөзді жаңарту',
      modalTitle: 'Растау',
      modalDesc: 'Құпия сөзді ауыстыру үшін поштаға растау кодын жіберу керек пе?',
      modalConfirm: 'Иә',
      modalCancel: 'Бас тарту',
      codeLabel: 'Email-ден тексеру коды',
      passwordChangedMsg: 'Құпия сөз сәтті өзгертілді',
      codeSentMsg: 'Құпия сөзді өзгерту коды Email-ге жіберілді.',
      profileSaved: 'Профиль сәтті сақталды.',
      profileSaveError: 'Профильді сақтау кезінде қате шықты',
      fillPasswordsRequired: 'Құпия сөзді толтырыңыз',
      passwordMinLength: 'Құпия сөз кемінде 8 таңбадан тұруы тиіс',
      editBtn: 'Өңдеу',
      saveBtn: 'Сақтау',
      cancelBtn: 'Болдырмау',
      notifTitle: 'Хабарлама параметрлері',
      notifDesc: 'Ботымыз арқылы лот мәртебелерінің өзгеруі туралы хабарлар алу үшін байланыс деректерін қосыңыз.',
      telegramLinked: 'Telegram байланыстырылған',
      telegramLinkBtn: 'Telegram байланыстыру',
      telegramLinking: 'Код жасалуда...',
      telegramLinkError: 'Код жасау сәтсіз аяқталды. Кейінірек қайталаңыз.',
      telegramWaiting: 'Боттың растауын күтудеміз...',
      telegramOpenDesktop: 'ДК-да Telegram ашу',
      telegramOpenMobile: 'Telegram қолданбасында ашу',
      telegramZoneDesktop: 'Компьютерде ашу',
      telegramZoneQr: 'QR-кодты сканерлеу',
      telegramZonePin: 'Кодты қолмен енгізу',
      telegramQrScan: 'Телефон камерасымен сканерлеңіз',
      telegramBotName: '@NotifierASPbot',
      telegramPinLabel: 'Растау коды:',
      telegramCopyPin: 'Көшіру',
      telegramCopied: 'Көшірілді!',
      telegramTimeout: 'Код мерзімі өтті. Жаңасын жасаңыз.',
      telegramSuccessToast: 'Telegram сәтті байланыстырылды!',
      telegramRetry: 'Жаңа код',
      telegramUnlink: 'Ажырату',
      telegramUnlinking: 'Ажыратылуда...',
      telegramUnlinkSuccess: 'Telegram сәтті ажыратылды',
      telegramUnlinkError: 'Ажырату сәтсіз аяқталды. Кейінірек қайталаңыз.',
      sidebarNav: 'Навигация',
      companyTitle: 'Компания профилі',
      companyDesc: 'Калькулятордағы ҚТК есебінде автоматты пайдаланылады',
      companyIncome: '3 жылдағы орташа жылдық табыс (₸)',
      companyTaxes: '3 жылда төленген салықтар (₸)',
      companyPfot: '3 жылдағы еңбекақы қоры (ЕҚТ) (₸)',
      companyHistoryTitle: 'Жылдар бойынша деректер',
      companyHistoryIncomeLabelBase: 'Жылдық жиынтабыс (100, 110, 130, 150) жылы үшін',
      companyHistoryTaxesLabelBase: 'Төленген салықтар',
      companyHistoryPfotLabelBase: 'Еңбекақы қоры (ЕҚТ)',
      companyHistoryYearWord: 'жылы үшін',
      companySave: 'Компания деректерін сақтау',
      companySaving: 'Сақталуда...',
      companySaved: 'Компания деректері сақталды!',
      companySaveError: 'Сақтау кезінде қате шықты',
      companyPdfTitle: 'PDF-тен импорт',
      companyPdfDrop: 'Госзакупоктің ҚТК үзіндісін апарыңыз немесе файл таңдаңыз',
      companyPdfHint: 'goszakup.gov.kz профиль бетінен ҚТК үзіндісі • макс. 5 МБ',
      companyPdfParsing: '✨ GLauncher магиясы: PDF-тен компания деректері алынуда...',
      companyPdfSuccess: 'Деректер сәтті алынып, сақталды!',
      companyPdfError400: 'Файл форматы қате немесе 5 МБ-тан артық',
      companyPdfError422: 'Деректерді алу мүмкін болмады. Дұрыс PDF-ті жүктегеніңізге көз жеткізіңіз',
      companyPdfErrorDefault: 'Файлды өңдеу кезінде қате шықты',
      security: {
        title: 'Қауіпсіздік және құрылғылар',
        sessionsTitle: 'Белсенді сессиялар',
        sessionsEmpty: 'Белсенді сессиялар жоқ',
        sessionsLoading: 'Сессиялар жүктелуде...',
        sessionTerminate: 'Аяқтау',
        sessionTerminating: 'Аяқталуда...',
        sessionTerminateConfirmTitle: 'Сессияны аяқтау?',
        sessionTerminateConfirmDesc: 'Құрылғыдан шығу жасалады.',
        sessionTerminateSelfTitle: 'Осы құрылғыдан шығу?',
        sessionTerminateSelfDesc: 'Сіз ағымдағы сессияны жойып жатырсыз. Сайттан шығарыласыз.',
        sessionTerminateSuccess: 'Сессия аяқталды',
        logoutAll: 'Барлық құрылғылардан шығу',
        logoutAllConfirmTitle: 'Барлық құрылғылардан шығу?',
        logoutAllConfirmDesc: 'Барлық басқа сессиялар аяқталады.',
        logoutAllSuccess: 'Барлық сессиялар аяқталды',
        historyTitle: 'Кіру тарихы',
        historyIp: 'IP-мекенжайы',
        historyDate: 'Кіру уақыты',
        historyEmpty: 'Кіру тарихы жоқ',
        unknownDevice: 'Белгісіз құрылғы',
        errNetwork: 'Желі қатесі. Қайталап көріңіз.',
        logoutAllLoading: 'Шығуда...',
        currentSession: 'Ағымдағы сессия',
      },
      payments: {
        title: 'Төлемдер тарихы',
        subtitle: 'Сіздің соңғы транзакцияларыңыз бен сатып алуларыңыз',
        colDate: 'Күні',
        colServices: 'Қызметтер',
        colAmount: 'Сомасы',
        colStatus: 'Мәртебесі',
        empty: 'Әзірге төлемдер жоқ',
        emptyDesc: 'Мұнда сатып алуларыңыз бен жазылымдарыңыз тарихы көрінеді',
        loading: 'Тарих жүктелуде...',
        error: 'Төлемдер тарихын жүктеу мүмкін болмады',
        retry: 'Қайталау',
        statusPaid: 'Төленген',
        statusPending: 'Өңделуде',
        statusFailed: 'Қате',
        statusRefunded: 'Қайтарым',
        subscription: 'Жазылым',
        subRenewal: 'Жазылымды ұзарту',
      },
    },
    fp: {
      title: 'Қаржылық жоспарлау',
      subtitle: 'Кері калькулятор: мақсатты сатып алу сомасына шығу үшін қандай көрсеткіштерді өсіру керектігін біліңіз',
      tabPlanning: 'Жоспарлау',
      tabHistory: 'Тарих',
      companyDataTitle: 'Компанияның қаржылық деректері',
      useCompanyBtn: 'Менің компаниямның деректерін пайдалану',
      useCompanyApplied: '✓ Компания деректері қолданылды',
      categoryLabel: 'Сатып алу санаты',
      categoryPlaceholder: 'Санат таңдаңыз...',
      amountLabel: 'Мақсатты сатып алу сомасы (₸)',
      mrpLabel: 'АЕК (өзгеріс)',
      mrpBase: 'Негізгі АЕК',
      mrpCustom: 'Кастомды АЕК',
      mrpHint: 'Жүргішпе АЕК өзгеріс пайызын белгілеңіз (+5 %…+10 %)',
      yearLabel: 'Жоспарлау жылы',
      yearValidation: 'Ағымдағыдан кіші жылды таңдауға болмайды',
      historyIncome1Label: 'Жыл−24 табысы (₸)',
      historyTaxes1Label: 'Жыл−24 салықтары (₸)',
      historyPfot1Label: 'Жыл−24 ЕҚТ (₸)',
      historyIncome2Label: 'Жыл−23 табысы (₸)',
      historyTaxes2Label: 'Жыл−23 салықтары (₸)',
      historyPfot2Label: 'Жыл−23 ЕҚТ (₸)',
      historyDataTitle: 'Деректер (мақсатты жылды есептеу үшін)',
      historyIncomeLabelBase: 'Жылдық жиынтабыс (100, 110, 130, 150) жылы',
      historyTaxesLabelBase: 'Төленген салықтар жылы',
      historyPfotLabelBase: 'Еңбекақы қоры (ЕҚТ) жылы',
      historyYearWord: '',
      btnCalculate: 'Жоспарлау талдауын бастау',
      confirmTitle: 'Талдауды іске қосуды растаңыз',
      confirmPlanDesc: 'Тарихи деректер мен сатып алу сомасы дұрыс енгізілгенін тексеріңіз. Жоспарлау есептеуінің бірі шығарылады.',
      confirmTierDesc: 'Тарихи деректер дұрыс енгізілгенін тексеріңіз. Тир талаптарын есептеудің бірі шығарылады.',
      confirmBtn: 'Иә, іске қосу',
      confirmCancel: 'Бас тарту',
      analyzing: 'Талдануда...',
      tierBannerTitle: 'Тирлар бойынша талаптар',
      tierBannerDesc: 'Таңдалған санат бойынша әрбір тир үшін қаржылық көрсеткіштердің шектік мәндерін біліңіз',
      tierBannerBtn: 'Тир талаптарын көрсету',
      tierBannerBtnBack: 'Сома жоспарлауына оралу',
      btnTier: 'Тир талаптарын есептеу',
      tierCalcRunning: 'Есептелуде...',
      scenarioCustom: 'Кастомды АЕК',
      scenarioMrp5: '+5 % АЕК',
      scenarioMrp10: '+10 % АЕК',
      scenarioBase: 'Негізгі АЕК',
      scenarioBaseHint: '(Ағымдағы, анықтамалыққа арналған)',
      resultReqPfu: 'Қажет ПҚТ',
      resultPdMin: 'Мин. ПД (табыс)',
      resultPunMin: 'Мин. ПСС (салық)',
      resultPfotMin: 'Мин. ЕҚТҞ',
      resultIncome3yrs: 'Мин. табыс 3 жыл (₸)',
      resultTaxes3yrs: 'Мин. салықтар 3 жыл (₸)',
      resultPfot3yrs: 'Мин. ЕҚТ 3 жыл (₸)',
      resultTargetTitle: 'Мақсатты жылда үстеу керек (₸)',
      resultTargetIncome: 'Табыс',
      resultTargetTaxes: 'Салықтар',
      resultTargetPfot: 'ЕҚТ',
      targetYearDone: 'Орындалды',
      resultMrpValue: 'АЕК мәні',
      resultAmountMrp: 'АЕК-дағы сома',
      resultPurchaseAmount: 'Сатып алу сомасы',
      resultTitle: 'Есептеу нәтижелері',
      resultYearsTitle: 'Есептелген жылдар',
      resultYear1: '1-жыл (target-4)',
      resultYear2: '2-жыл (target-3)',
      resultYear3target: 'Мақсатты жыл',
      tierLabel: 'Тир',
      tierReqPfu: 'Қажет ПҚТ',
      tierReqPd: 'Қажет ПД',
      tierReqPun: 'Қажет ПСС',
      tierReqPfot: 'Қажет ЕҚТҞ',
      noCompanyTitle: 'Компания профилі толтырылмаған',
      noCompanyDesc: 'Есептеу үшін компанияның қаржылық деректері қажет.',
      noCompanyClose: 'Жабу',
      limitPlanning: 'Қол жоспарлау есептеулері',
      limitTier: 'Қол тир есептеулері',
      limitBuyLink: 'Балансты толтыру',
      error402: 'Лимит таусып бітті. Жеке кабинетінде балансты толтырыңыз.',
      error404: 'Санат табылмады',
      error422: 'Деректерді тексеріңіз (сома > 0 болуы керек)',
      errorDefault: 'қате орын алды. Кейінірек әрекет етіңіз.',
      historyEmpty: 'Жоспарлау тарихы бос',
      historyEmptyDesc: 'Алғашқы есептеуді іске қосыңыз, ол осында пайда болады',
      historyDate: 'Күні',
      historyCategory: 'Санат',
      historyAmount: 'Мақсатты сома',
      historyType: 'Түрі',
      historyTypePlanning: 'Жоспарлау',
      historyTypeTier: 'Тир талдауы',
      historyDetailTitle: 'Есептеу мәліметтері',
      historyDetailClose: 'Жабу',
      pdfLabel: 'PDF-тен жылдам импорт',
      pdfDrop: 'Госзакупок PDF-үзіндісін апарыңыз немесе файл таңдаңыз',
      pdfHint: 'goszakup.gov.kz профилінен ПҚТ үзіндісі • макс. 5 МБ',
      pdfParsing: '✨ GLauncher магиясы: деректер алынуда...',
      pdfSuccess: 'Деректер сәтті алынды!',
      pdfError400: 'Форматы қате немесе файл > 5 МБ',
      pdfError422: 'Деректер табылмады. Дұрыс PDF жүктеңіз',
      pdfErrorDefault: 'Файлды өңдеу кезінде қате шықты',
      pdfHide: 'Жасыру',
    },
    admin: {
      title: 'Әкімшілік панель',
      statMillions: 'млн ₸',
      statThousands: 'мың ₸',
      statDays7: '7к',
      statDays30: '30к',
      statPfu: 'ҚТК',
      tierPrefix: 'Тир',
      tiersCount: 'Тирлер',

      badge: 'ADMIN',
      navDashboard: 'Басқару тақтасы',
      navUsers: 'Пайдаланушылар',
      navBilling: 'Биллинг',
      navSubscriptions: 'Жазылымдар',
      navSettings: 'ҚТК параметрлері',
      navTenders: 'Тендер трекері',
      navAuditLog: 'Өзгерістер журналы',
      accessDenied: 'Қол жеткізу тыйым салынды',
      accessDeniedDesc: 'Бұл бетті қарауға жеткілікті рұқсатыңыз жоқ.',
      backToSite: 'Басты сайтқа',
      loading: 'Жүктелуде...',
      errorLoad: 'Деректерді жүктеу қатесі',
      retry: 'Қайталау',
      save: 'Сақтау',
      saving: 'Сақталуда...',
      saved: 'Сақталды',
      cancel: 'Бас тарту',
      delete: 'Жою',
      deleting: 'Жойылуда...',
      edit: 'Өңдеу',
      create: 'Жасау',
      confirm: 'Растау',
      search: 'Іздеу',
      searchPlaceholder: 'Email, аты, телефон...',
      noData: 'Деректер жоқ',
      total: 'Барлығы',
      actions: 'Әрекеттер',
      yes: 'Иә',
      no: 'Жоқ',
      close: 'Жабу',
      from: 'бастап',
      to: 'дейін',
      period: 'Кезең',
      status: 'Мәртебе',
      all: 'Барлығы',
      of: 'ішінен',
      pagePrev: '← Артқа',
      pageNext: 'Алға →',

      dashboardTitle: 'Платформаны шолу',
      statTotalUsers: 'Барлық пайдаланушылар',
      statNewToday: 'Бүгін жаңа',
      statNewWeek: 'Аптада жаңа',
      statNewMonth: 'Айда жаңа',
      statActiveToday: '24 сағатта белсенді',
      statActiveMonth: '30 күнде белсенді',
      statTotalRevenue: 'Жалпы табыс',
      statMrr: 'MRR (ағымдағы ай)',
      statTotalOrders: 'Барлық тапсырыстар',
      statPfuBurns: '24 сағатта ҚТК жанды',
      statTrackerBurns: '24 сағатта трекер оқиғалары',
      statBurnRateRatio: 'Burn Rate 24 сағат: ҚТК vs Трекер',
      chartRegistrations: '30 күндегі тіркелулер',
      chartDate: 'Күн',
      chartCount: 'Сан',

      usersTitle: 'Пайдаланушыларды басқару',
      filterActive: 'Белсенді',
      filterInactive: 'Белсенді емес',
      filterTelegram: 'Telegram',
      filterAll: 'Барлығы',
      filterHasTg: 'Telegram бар',
      filterNoTg: 'Telegram жоқ',
      colEmail: 'Email',
      colName: 'Аты',
      colPhone: 'Телефон',
      colTelegram: 'Telegram',
      colActive: 'Белсенді',
      colVerified: 'Расталған',
      colRole: 'Рөл',
      colBalance: 'Баланс (ҚТК/VIP/Слоттар)',
      colRegistered: 'Тіркелген күні',
      colLastLogin: 'Соңғы кіру',
      colIncome: 'Кіріс 3 жыл (₸)',
      viewDetail: 'Толығырақ',
      userDetailTitle: 'Пайдаланушы профилі',
      tabProfile: 'Профиль',
      tabBalance: 'Баланс',
      tabHistory: 'Тарих',
      balanceTitle: 'Балансты басқару',
      balancePfu: 'ҚТК есептеулер',
      balanceVip: 'VIP есептеулер',
      balanceTracker: 'Трекер слоттары',
      balancePlanning: 'Жоспарлау есептеулері',
      balanceTier: 'Тир есептеулері',
      balanceDeltaHint: 'Оң немесе теріс санды енгізіңіз (−3 = 3 шегеру)',
      balanceReasonLabel: 'Өзгерту себебі',
      balanceReasonPlaceholder: 'Мысалы: өтемақы, акция, қате тапсырыс',
      balanceApply: 'Өзгерісті қолдану',
      balanceApplying: 'Қолданылуда...',
      balanceSuccess: 'Баланс сәтті жаңартылды',
      balanceError: 'Балансты жаңарту қатесі',
      roleTitle: 'Пайдаланушы рөлі',
      roleChange: 'Рөлді өзгерту',
      roleChanging: 'Өзгертілуде...',
      roleChanged: 'Рөл өзгертілді',
      unlockTitle: 'Аккаунтты бұғаттау',
      unlockBtn: 'Бұғатсыздандыру',
      unlocking: 'Бұғатсыздандырылуда...',
      unlocked: 'Аккаунт бұғатсыздандырылды',
      lockedUntil: 'Дейін бұғатталған',
      lockTitle: 'Аккаунтты бұғаттау',
      lockBtn: 'Бұғаттау',
      locking: 'Бұғатталуда...',
      lockConfirmBody: 'Аккаунтты бұғаттағыңызға сенімдісіз бе? Пайдаланушы атып шыға мүмкін болмайды.',
      accountBlocked: 'Аккаунт әкімші тарапынан бұғатталған',
      accountRateLocked: 'Аккаунт әрекет саны асып кеткені бұғатталған',
      activateBtn: 'Белсендіру',
      activating: 'Белсендірілуде...',
      historySourcePfu: 'ҚТК есептеу',
      historySourcePlanning: 'Жоспарлау',
      historySourceTracker: 'Трекер',
      historyEmpty: 'Тарих бос',

      billingTabOrders: 'Транзакциялар',
      billingTabPrices: 'Бағаларды басқару',

      billingTitle: 'Биллинг және транзакциялар',
      colOrderId: 'Order ID',
      colAmount: 'Сома',
      colCurrency: 'Валюта',
      colOrderStatus: 'Мәртебе',
      colItems: 'Позициялар',
      colDate: 'Күні',
      statusPaid: 'Төленді',
      statusPending: 'Күтілуде',
      statusFailed: 'Қате',
      statusRefunded: 'Қайтарылды',
      filterStatusAll: 'Барлық мәртебелер',

      refundBtn: 'Қайтару',
      refundConfirmTitle: 'Қайтаруды растау',
      refundConfirmDesc: '{id} тапсырысы бойынша {amount} сомасын қайтару? Пайдаланушының токендері шегеріледі.',
      refunding: 'Қайтарылуда...',
      refundSuccess: 'Қайтару орындалды',
      refundError: 'Қайтару қатесі',

      exportCsv: 'CSV экспорты',
      exportExcel: 'Excel жүктеу',

      pricesTitle: 'Қызметтер бағасын басқару',
      pricesSubtitle: 'Өзгерістер барлық жаңа сатып алуларға дереу қолданылады.',
      priceService: 'Қызмет',
      priceAmount: 'Баға (₸)',
      priceEdit: 'Өзгерту',
      priceConfirmTitle: 'Баға өзгертуін растау',
      priceConfirmDesc: '«{label}» бағасын {old} ₸-ден {new} ₸-ге өзгертесіз. Бұл барлық жаңа сатып алуларға дереу әсер етеді.',
      priceSave: 'Бағаны сақтау',
      priceSaving: 'Сақталуда...',
      priceSaved: 'Баға жаңартылды',
      priceNotConfigured: 'Баға белгіленбеген. Жеке сатып алу баға орнатылғаннан кейін қолжетімді.',
      balanceExperience: 'Тәжірибе есептері',
      priceError: 'Баға жаңарту қатесі',
      priceCancel: 'Бас тарту',
      priceConfirm: 'Иә, жаңарту',
      priceLoading: 'Бағалар жүктелуде...',

      // Subscriptions
      subsTitle: 'Жазылымдар',
      subsTabPlans: 'Тарифтер',
      subsTabSubscribers: 'Жазылушылар',
      subsCreatePlan: 'Тариф құру',
      subsMonth: 'ай',
      subsUnit: 'дана',
      subsFilterAll: 'Барлығы',
      subsNoPlans: 'Тарифтер әлі құрылмаған',
      subsNoSubscribers: 'Жазылушылар әзірге жоқ',
      subsStatusDraft: 'Жоба',
      subsStatusActive: 'Белсенді',
      subsStatusArchived: 'Мұрағат',
      subsRetailValue: 'Пакет құндылығы',
      subsRetailValueHint: 'Кіретін қызметтердің бөлшек баға бойынша құны',
      subsEdit: 'Өзгерту',
      subsActivate: 'Белсендіру',
      subsArchive: 'Мұрағаттау',
      subsDelete: 'Жою',
      subsNewPlan: 'Жаңа тариф',
      subsEditPlan: 'Тарифті өзгерту',
      subsPlanName: 'Тариф атауы',
      subsPlanNamePlaceholder: 'Мысалы: Стандарт',
      subsPlanDesc: 'Сипаттама',
      subsPlanDescPlaceholder: 'Клиенттерге арналған қысқаша сипаттама...',
      subsPlanPrice: 'Айлық баға',
      subsSortOrder: 'Сұрыптау реті',
      subsFeatured: 'Ұсынылатын',
      subsFeaturedHint: 'Тарифтер бетінде ерекшелеу',
      subsServiceConditions: 'Қызметтер бойынша шарттар',
      subsColService: 'Қызмет',
      subsColIncluded: 'Кіреді (дана/ай)',
      subsColDiscount: 'Жеңілдік (кірмесе)',
      subsSave: 'Сақтау',
      subsSaving: 'Сақталуда...',
      subsErrName: 'Тариф атауын көрсетіңіз',
      subsErrPrice: 'Дұрыс баға көрсетіңіз',
      subsErrorSave: 'Тарифті сақтау қатесі',
      subsCreated: 'Тариф құрылды (жоба)',
      subsUpdated: 'Тариф жаңартылды',
      subsActivated: 'Тариф белсендірілді',
      subsArchivedMsg: 'Тариф мұрағатқа жіберілді',
      subsDeletedMsg: 'Тариф жойылды',
      subsDeleteBlocked: 'Белсенді жазылушылары бар тарифті жою мүмкін емес — алдымен оны мұрағаттаңыз',
      subsArchiveConfirmTitle: 'Тарифті мұрағаттау керек пе?',
      subsArchiveConfirmBody: 'Бұл тарифте {count} белсенді жазылушы бар. Жаңа жазылымдар қолжетімсіз болады, бұрынғы клиенттер тарифті пайдалануды жалғастырады.',
      subsDeleteConfirmTitle: 'Тарифті жою керек пе?',
      subsDeleteConfirmBody: 'Тариф біржола жойылады. Бұл тек белсенді жазылушылар болмаған жағдайда мүмкін.',
      subsColClient: 'Клиент',
      subsColPlan: 'Тариф',
      subsColStatus: 'Күйі',
      subsColStarted: 'Жазылған күні',
      subsColNextBilling: 'Келесі есептен шығару',
      subsColLastPayment: 'Соңғы төлем',
      subsSubStatusActive: 'Белсенді',
      subsSubStatusCancelled: 'Тоқтатылған',
      subsSubStatusExpired: 'Мерзімі өткен',
      subsActiveUntil: 'дейін белсенді',
      subsFilterByPlan: 'Барлық тарифтер',
      orderSubscription: 'Жазылым (қосылу)',
      orderSubRenewal: 'Жазылым (жаңарту)',

      settingsTitle: 'Жүйе және ҚТК параметрлері',
      mrpTitle: 'Жаһандық параметрлер',
      mrpLabel: 'Ағымдағы МЕТ (₸)',
      mrpHint: 'МЕТ мәні барлық ҚТК есептеулеріне нақты уақытта әсер етеді.',
      mrpSave: 'МЕТ жаңарту',
      mrpSaving: 'Сақталуда...',
      mrpSaved: 'МЕТ жаңартылды',
      mrpError: 'МЕТ жаңарту қатесі',
      categoriesTitle: 'ҚТК санаттары',
      categoryKey: 'Кілт (key)',
      categoryName: 'Атауы',
      categoryCoefficients: 'Коэффициенттер',
      categoryTiers: 'Тирлер',
      addCategory: 'Санат қосу',
      editCategory: 'Санатты өңдеу',
      deleteCategory: 'Санатты жою',
      deleteCategoryConfirm: '«{name}» санатын жойғыңыз келетіне сенімдісіз бе? Бұл барлық есептеулерге әсер етеді.',
      minPd: 'min_pd_value',
      multPd: 'mult_pd',
      minPun: 'min_pun_value',
      multPun: 'mult_pun',
      minPfot: 'min_pfot_value',
      multPfot: 'mult_pfot',
      tierMaxMrp: 'max_mrp (null = шексіз)',
      tierReqPd: 'req_pd',
      tierReqPun: 'req_pun',
      tierReqPfot: 'req_pfot',
      tierReqPfu: 'req_pfu',
      addTier: 'Тир қосу',
      removeTier: 'Тирді жою',
      categoryCreated: 'Санат жасалды',
      categoryUpdated: 'Санат жаңартылды',
      categoryDeleted: 'Санат жойылды',
      categoryError: 'Санатты сақтау қатесі',

      tendersTitle: 'Трекер мен жұмысшыларды бақылау',
      colAnno: 'Хабарлама нөмірі',
      colUserId: 'Пайдаланушы ID',
      colDiscussion: 'Хаттама',
      colNotifPlatform: 'Хабарлау',
      colCreated: 'Жасалды',
      colUpdated: 'Жаңартылды',

      // Tracker page
      trackerStatTotal: 'Барлық жазбалар',
      trackerStatProtocol: 'Хаттама алынды',
      trackerStatNotified: 'Хабарланды',
      trackerStatUnique: 'Бенерсіз тендерлер',
      trackerStatUsers: 'Пайдаланушылар',
      trackerSearchPlaceholder: 'Хабарлама нөмірі бойынша іздеу...',
      trackerFilterWaiting: 'Хаттама күтеді',
      trackerFilterFound: 'Хаттама шықты',
      trackerFilterNotified: 'Хабарланғандар',
      trackerColUser: 'Пайдаланушы',
      trackerColStatus: 'Тендер мәртебесі',
      trackerProtocolYes: 'Шықты',
      trackerProtocolNo: 'Шықпаған',

      // Worker health
      workerTitle: 'Жұмысшы мәртебесі',
      workerRedis: 'Redis / Celery',
      workerRedisOk: 'қол жетімді',
      workerRedisErr: 'қол жетімсіз',
      workerLastRun: 'Соңғы іске',
      workerNeverRun: 'Ешқашан іскермеді',
      workerJustNow: 'қазір ғана',
      workerMinsAgo: 'мин. бұрын',
      workerHrsAgo: 'сағ. бұрын',
      workerRunStatus: 'Нәтиже',
      workerStatusOk: 'Сәтті',
      workerStatusRunning: 'Орындалуда',
      workerStatusError: 'Қате',
      workerChecked: 'Тексерілді',
      workerNotified: 'Хабарланды',
      workerStatusChanges: 'Мәртебе өзгерістері',
      workerScheduleDesc: 'Кесте: әр {n} мин. сайын',
      workerTriggerBtn: 'қазір іске',
      workerTriggering: 'Іске қосуда...',
      workerTriggerSuccess: 'Тапсырма кезекке қосылды',
      workerTriggerError: 'Іске қатесі',

      // Force sync
      forceSyncTitle: 'Force Sync',
      forceSyncDesc: 'Госзакуптан хабарлама нөмірі бойынша тендерді мәжбүрлі тексеру.',
      forceSyncPlaceholder: 'Хабарлама нөмірі (мыс.: 17005447-1)',
      forceSyncBtn: 'Тексеру',
      forceSyncRunning: 'Тексерілуде...',
      forceSyncFound: 'Тендер Госзакупта табылды',
      forceSyncNotFoundOws: 'Тендер Госзакупта табылмады',
      forceSyncNotInDb: 'Жүйе бұл нөмірді бақыламайды',
      forceSyncProtocolFound: 'Талқылау хаттамасы табылды',
      forceSyncNoProtocol: 'Талқылау хаттамасы жоқ',
      forceSyncStatusChanged: 'Мәртебе өзгерді',
      forceSyncNoChanges: 'Өзгеріс жоқ',
      forceSyncUpdated: 'Жазбалар жаңартылды',

      auditTitle: 'Әкімшілік әрекеттер журналы',
      auditAdmin: 'Әкімші',
      auditAction: 'Әрекет',
      auditTarget: 'Мақсатты пайдаланушы',
      auditDetail: 'Мәліметтер',
      auditDate: 'Күні',
      auditExport: 'Excel жүктеу',
      auditSearchAdmin: 'Әкімші email бойынша іздеу',
      auditFilterAllActions: 'Барлық әрекеттер',
      auditDateFrom: 'Бастап',
      auditDateTo: 'Дейін',
      auditClearFilters: 'Сүзгілерді тазалау',
      auditColSummary: 'Сипаттама',
      auditDetailTitle: 'Әрекет мәліметтері',
      auditDetailAdmin: 'Әкімші',
      auditDetailTarget: 'Пайдаланушы',
      auditDetailData: 'Әрекет деректері',
      auditShowJson: 'JSON',
      auditHideJson: 'JSON жасыру',
      // Action labels
      auditAction_balance_update: 'Баланс',
      auditAction_role_change: 'Рөл',
      auditAction_toggle_active: 'Активация',
      auditAction_account_unlock: 'Бұғатсыздандыру',
      auditAction_contact_update: 'Байланыс',
      auditAction_welcome_bonus: 'Бонус',
      auditAction_admin_reset_password: 'Құпия сөз',
      auditAction_order_refund: 'Қайтару',
      auditAction_price_update: 'Баға',
      auditAction_mrp_update: 'МЕТ',
      auditAction_category_create: 'Санат ++',
      auditAction_category_update: 'Санат',
      auditAction_category_delete: 'Санат --',
      auditAction_worker_trigger: 'Жұмысшы',
      auditAction_force_sync: 'Force Sync',
      auditAction_subscription_plan_create: 'Тариф ++',
      auditAction_subscription_plan_update: 'Тариф',
      auditAction_subscription_plan_activate: 'Тариф қосу',
      auditAction_subscription_plan_archive: 'Тариф мұрағат',
      auditAction_subscription_plan_delete: 'Тариф --',
      auditAction_document_create: 'Құжат ++',
      auditAction_document_update: 'Құжат',
      auditAction_document_publish: 'Жариялау',
      auditAction_document_restore: 'Қалпына келтіру',
      auditAction_document_delete: 'Құжат --',
      calcTypeReversePlanning: 'Кері жоспарлау',
      calcTypeTierRequirements: 'Тир талаптары',

      tabLoginHistory: 'Кірулер',
      tabBillingHistory: 'Сатып алулар',
      tabActivityHistory: 'Белсенділік',
      loginHistoryIp: 'IP-мекенжай',
      loginHistoryDate: 'Кіру күні',
      loginHistoryEmpty: 'Кіру тарихы бос',
      billingHistoryEmpty: 'Сатып алулар жоқ',

      welcomeBonus: 'Қош келдіңіз бонусын беру',
      welcomeBonusSending: 'Беріліуде...',
      welcomeBonusSuccess: 'Қош келдіңіз бонусы берілді!',
      welcomeBonusError: 'Бонус беру қатесі',
      welcomeBonusDesc: 'Стандартты токендер жиынтығын береді (5 ҚТК, 3 трекер слоты, 3 жоспарлау, 5 тир)',

      resetPasswordBtn: 'Құпия сөзді қалпына келтіру кодын жасау',
      resetPasswordGenerating: 'Жасалуда...',
      resetPasswordSuccess: 'Код жасалды және emailге жіберілді',
      resetPasswordError: 'Код жасау қатесі',
      resetPasswordCode: 'Қалпына келтіру коды',
      resetPasswordExpires: 'Дейін жарамды',
      resetPasswordCopy: 'Көшіру',
      resetPasswordCopied: 'Көшірілді!',

      editContactTitle: 'Байланыс деректерін өңдеу',
      contactName: 'Аты',
      contactSurname: 'Тегі',
      contactPhone: 'Телефон',
      contactWhatsapp: 'WhatsApp',
      contactSave: 'Сақтау',
      contactSaving: 'Сақталуда...',
      contactSaved: 'Байланыстар жаңартылды',
      contactError: 'Сақтау қатесі',

      // Clients/Staff tabs
      tabClients: 'Клиенттер',
      tabStaff: 'Қызметкерлер',
      staffDesc: 'Қызметкерлер әкімшілік функцияларға қол жеткізу үшін ba.',
      filterRoleAll: 'Барлық рөлдер',
      addStaff: 'Қызметкер қосу',
      addStaffTitle: 'Қызметкер қосу',
      addStaffDesc: 'Тізімнен пайдаланушыны таңдап, оған қызметкер рөлін тағдаңыз.',
      addStaffSearch: 'Email, аты немесе телефон бойынша іздеу...',
      addStaffSelectRole: 'Рөлді таңдаңыз',
      addStaffRoleHint: 'analyst — оқу, manager — пайдаланушыларды басқару, superadmin — толық қол жеткізу.',
      addStaffConfirm: 'Рөлді тағдау',
      addStaffConfirming: 'Тағдалуда...',
      addStaffSuccess: 'Рөл сәтті тағдалды',
      addStaffError: 'Рөл тағдау қатесі',

      // Activate/Deactivate
      activateUser: 'Белсендіру',
      deactivateUser: 'Өшіру',
      activateSuccess: 'Пайдаланушы мәртебесі өзгертілді',
      activateError: 'Мәртебені өзгерту қатесі',

      // Confirm dialogs
      confirmRoleChange: 'Бұл пайдаланушының рөлін өзгерткіңіз келе ме?',
      confirmBonus: 'Бұл пайдаланушыға қош келді бонусын беру?',
      confirmReset: 'Бұл пайдаланушы үшін құпия сөзді қалпына келтіру кодын жасау?',

      // History labels
      historyCategory: 'Санат',
      historyPasses: 'Ең жоғары балл',
      historyCalcType: 'Есептеу түрі',
      historyContest: 'Конкурс',
      historyStatus: 'Мәртебе',

      chartRevenue: '30 күндегі табыс',
      chartRevenue30dSub: 'Кейінгі 30 күндегі табыс динамикасы',
      chartFeatureUsage: '30 күндегі мүмкіндік тұтынуы',
      chartFeatureUsageSub: 'Күн бойынша ҚТК, бақылау және тәжірибені есептеу',
      chartRevenueY: 'Табыс (₸)',
      chartRegistrationsY: 'Тіркелулер',
      chartRegistrationsSub: 'Кейінгі 30 күндегі жаңа пайдаланушылар',
      lastUpdated: 'Деректер нақты',
      statRevenueMonth: 'Айлық табыс',
      statRevenue30d: '30к табыс',
      statArpu: 'ARPU',
      statOrders30d: '30 күндегі тапсырыстар',
      statAvgOrder: 'Орташа чек',
      statVerified: 'Расталған',
      statPlanningBurns: 'Жоспарлау 24с',
      statExperienceBurns: 'Тәжірибені есептеу 24с',
      experienceUsage30d: '30 күндегі тәжірибе есептері',
      statActiveUsers: 'Белсенді пайдаланушылар',
      statActiveUsersDesc: 'Барлық пайдаланушылардан белсенділер үлесі',
      featureBurns: 'Қызметтерді пайдалану',
      featureBurnsDesc: '24 сағат ішіндегі қоңыру саны',
      platformHealth: 'Платформа денсаулығы',
      platformHealthDesc: 'Платформаның қаржылық көрсеткіштері',
      productBreakdown: 'Өнімдер бойынша табыс',
      productBreakdownSub: 'Төленген тапсырыстардың бөлінуі',
      recentSignups: 'Соңғы тіркелулер',
      recentOrders: 'Соңғы сатып алулар',

      // Site settings
      navSiteSettings: 'Сайт параметрлері',
      navPromotions: 'Жарнама',
      siteSettings: {
        title: 'Сайт параметрлері',
        subtitle: 'Сайттың мазмұны мен параметрлерін басқару',
        sectionsTitle: 'Бөлімдер',
        navDocuments: 'Құжаттар',
        navNews: 'Жаңалықтар',
        navNewsCategories: 'Жаңалық рубрикалары',
        news: {
          title: 'Сайт жаңалықтары',
          addNew: 'Жаңалық қосу',
          searchPlaceholder: 'Тақырып бойынша іздеу...',
          loadError: 'Жаңалықтарды жүктеу мүмкін болмады',
          actionError: 'Әрекетті орындау мүмкін болмады',
          uploadError: 'Суретті жүктеу мүмкін болмады',
          empty: 'Әзірге жаңалықтар жоқ',
          allStatuses: 'Барлық статустар',
          allCategories: 'Барлық рубрикалар',
          published: 'Жарияланды',
          draft: 'Жоба',
          featured: 'Бекітілген',
          updated: 'Жаңартылды',
          views: 'Қараулар',
          feature: 'Бекіту',
          unfeature: 'Бекітуді алу',
          publish: 'Жариялау',
          unpublish: 'Жариялаудан алу',
          publishedDone: 'Жаңалық жарияланды',
          unpublishedDone: 'Жаңалық жариялаудан алынды',
          edit: 'Өңдеу',
          delete: 'Жою',
          deleteTitle: 'Жаңалықты жою',
          deleteConfirm: 'Жоюға сенімдісіз бе',
          createTitle: 'Жаңа жаңалық',
          create: 'Құру',
          cancel: 'Болдырмау',
          createValidation: 'Тақырып пен мекенжайды (slug) енгізіңіз',
          titleRu: 'Тақырып (орыс)',
          titleKk: 'Тақырып (қаз)',
          titleField: 'Тақырып',
          category: 'Рубрика',
          noCategory: 'Рубрикасыз',
          slugLabel: 'Мекенжай (slug)',
          slugHint: 'Сілтеме:',
          back: 'Тізімге',
          save: 'Сақтау',
          saved: 'Сақталды',
          history: 'Тарих',
          historyTitle: 'Нұсқалар тарихы',
          historyEmpty: 'Әзірге нұсқалар жоқ',
          version: 'Нұсқа',
          restore: 'Қалпына келтіру',
          restoreConfirm: 'Осы нұсқаны қалпына келтіресіз бе? Ағымдағы мазмұн тарихқа сақталады.',
          restoreDone: 'Нұсқа қалпына келтірілді',
          preview: 'Алдын ала қарау',
          editMode: 'Редактор',
          unsaved: 'Сақталмаған өзгерістер бар',
          unsavedConfirm: 'Сақталмаған өзгерістер бар. Беттен кетуге бола ма?',
          emptyContent: 'Мазмұн бос',
          excerpt: 'Қысқаша сипаттама',
          excerptHint: 'Карточкалар мен SEO үшін қысқа анонс',
          body: 'Мақала мәтіні',
          publishSection: 'Жариялау',
          metaSection: 'Параметрлер',
          cover: 'Мұқаба',
          uploadCover: 'Жүктеу',
          removeCover: 'Мұқабаны жою',
          tags: 'Тегтер',
          tagsHint: 'үтір арқылы',
          author: 'Автор',
          seoTitle: 'SEO-тақырып',
          seoDescription: 'SEO-сипаттама',
          langRu: 'Орыс',
          langKk: 'Қаз',
          cat: {
            title: 'Жаңалық рубрикалары',
            addNew: 'Рубрика қосу',
            loadError: 'Рубрикаларды жүктеу мүмкін болмады',
            actionError: 'Әрекетті орындау мүмкін болмады',
            empty: 'Әзірге рубрикалар жоқ',
            postCount: 'Жаңалықтар',
            order: 'Реттілігі',
            createTitle: 'Жаңа рубрика',
            editTitle: 'Рубриканы өңдеу',
            titleRu: 'Атауы (орыс)',
            titleKk: 'Атауы (қаз)',
            key: 'Кілт',
            validation: 'Атауы мен кілтті енгізіңіз',
            save: 'Сақтау',
            cancel: 'Болдырмау',
            delete: 'Жою',
            deleteTitle: 'Рубриканы жою',
            deleteConfirm: 'Рубриканы жою',
            deleteWarn: '{n} жаңалықтан рубрика алынады.',
          },
        },
        docs: {
          title: 'Сайт құжаттары',
          addNew: 'Құжат қосу',
          searchPlaceholder: 'Атауы немесе мекенжайы бойынша іздеу...',
          loadError: 'Құжаттарды жүктеу мүмкін болмады',
          actionError: 'Әрекетті орындау мүмкін болмады',
          empty: 'Құжаттар табылмады',
          systemBadge: 'Жүйелік',
          published: 'Жарияланған',
          draft: 'Жоба',
          version: 'Нұсқа',
          updated: 'Жаңартылды',
          edit: 'Өңдеу',
          delete: 'Жою',
          cannotDelete: 'Жүйелік құжатты жою мүмкін емес',
          publish: 'Жариялау',
          unpublish: 'Жариялаудан алу',
          createTitle: 'Жаңа құжат',
          titleRu: 'Атауы (орыс)',
          titleKk: 'Атауы (қаз)',
          slugLabel: 'Мекенжай (slug)',
          slugHint: 'Сайттағы сілтеме:',
          createValidation: 'Екі тілде атауын және мекенжайын толтырыңыз',
          create: 'Құру',
          cancel: 'Болдырмау',
          deleteTitle: 'Құжатты жою керек пе?',
          deleteConfirm: 'Шынымен жойғыңыз келе ме',
          back: 'Артқа',
          save: 'Сақтау',
          saved: 'Сақталды',
          history: 'Тарих',
          upload: 'Word/PDF жүктеу',
          preview: 'Алдын ала қарау',
          editMode: 'Өңдегіш',
          unsaved: 'Сақталмаған өзгерістер бар',
          docTitle: 'Құжат атауы',
          langRu: 'Русский',
          langKk: 'Қазақша',
          uploadReplaceConfirm: 'Ағымдағы мазмұн жүктелген құжатпен ауыстырылады. Жалғастырасыз ба?',
          uploadError: 'Файлды өңдеу мүмкін болмады. .docx немесе .pdf жүктеңіз.',
          unsavedConfirm: 'Сақталмаған өзгерістер бар. Беттен кетесіз бе?',
          restoreConfirm: 'Осы нұсқаны қалпына келтіру керек пе? Ағымдағы мазмұн тарихта сақталады.',
          restoreDone: 'Нұсқа қалпына келтірілді',
          emptyContent: 'Мазмұн жоқ',
          historyTitle: 'Нұсқалар тарихы',
          historyEmpty: 'Өзгерістер тарихы бос',
          restore: 'Қалпына келтіру',
        },
        editor: {
          linkPrompt: 'Сілтеме URL мекенжайын енгізіңіз',
          imagePrompt: 'Сурет URL мекенжайын енгізіңіз',
          undo: 'Болдырмау',
          redo: 'Қайталау',
          fontFamily: 'Қаріп',
          fontDefault: 'Қаріп',
          fontSize: 'Өлшем',
          sizeDefault: 'Өлшем',
          bold: 'Қалың',
          italic: 'Көлбеу',
          underline: 'Асты сызылған',
          strike: 'Сызылған',
          textColor: 'Мәтін түсі',
          highlight: 'Бөлектеу',
          paragraph: 'Абзац',
          h1: 'Тақырып 1',
          h2: 'Тақырып 2',
          h3: 'Тақырып 3',
          alignLeft: 'Сол жаққа',
          alignCenter: 'Ортаға',
          alignRight: 'Оң жаққа',
          alignJustify: 'Еніне қарай',
          bulletList: 'Маркерленген тізім',
          orderedList: 'Нөмірленген тізім',
          blockquote: 'Дәйексөз',
          link: 'Сілтеме',
          unlink: 'Сілтемені алып тастау',
          image: 'Сілтеме арқылы сурет',
          imageUpload: 'Құрылғыдан сурет жүктеу',
          imageUploadError: 'Суретті жүктеу мүмкін болмады',
          table: 'Кесте',
          horizontalRule: 'Көлденең сызық',
          clearFormatting: 'Пішімдеуді тазалау',
          placeholder: 'Құжат мәтінін енгізе бастаңыз...',
        },
      },

      // Server Status
      navServerStatus: 'Сервер күйі',
      serverStatusTitle: 'Сервер күйі',
      serverStatusDesc: 'Инфрақұрылым метрикалары нақты уақытта',
      serverStatusTabMetrics: 'Метрикалар',
      serverStatusTabLogs: 'Журналдар',
      serverStatusRefresh: 'Жаңарту',
      serverStatusRefreshing: 'Жаңартылуда...',
      serverStatusFetchedAt: 'Деректер алынды',
      serverStatusAutoRefresh: 'Авто',
      serverStatusAutoOff: 'Өшіру',

      serverServicesTitle: 'Сервистер күйі',
      serverServiceApi: 'API',
      serverServiceMongo: 'MongoDB',
      serverServiceRedis: 'Redis',
      serverServiceCelery: 'Celery',
      serverServiceOnline: 'Online',
      serverServiceOffline: 'Offline',

      serverSystemTitle: 'Сервер ресурстары',
      serverSystemCpu: 'CPU жүктемесі',
      serverSystemRam: 'RAM жады',
      serverSystemDisk: 'Диск',
      serverSystemUptime: 'Сервер жұмыс уақыты',
      serverSystemApiStarted: 'API іске қосылды',
      serverSystemCores: 'ядро',
      serverSystemUsed: 'пайдаланылды',
      serverSystemFree: 'бос',

      serverMongoTitle: 'MongoDB',
      serverMongoConnCurrent: 'Қосылымдар',
      serverMongoConnAvail: 'Қолжетімді',
      serverMongoUptime: 'Жұмыс уақыты',
      serverMongoDbSize: 'ДҚ өлшемі',
      serverMongoCollections: 'Коллекциялар',
      serverMongoObjects: 'Құжаттар',
      serverMongoOps: 'Операциялар (барлығы)',

      serverRedisTitle: 'Redis',
      serverRedisMemUsed: 'Жад',
      serverRedisMemPeak: 'Шарықтау',
      serverRedisClients: 'Клиенттер',
      serverRedisOps: 'Ops/сек',
      serverRedisKeys: 'Кілттер',
      serverRedisUptime: 'Жұмыс уақыты',

      serverCeleryTitle: 'Celery / Воркер',
      serverCeleryLastRun: 'Соңғы іске қосу',
      serverCeleryStatus: 'Мәртебе',
      serverCeleryTenders: 'Тексерілген тендерлер',
      serverCeleryNotifs: 'Хабарландырулар',
      serverCelerySchedule: 'Кесте',
      serverCeleryScheduleVal: 'әр {n} мин. сайын',
      serverCeleryNeverRun: 'Ешқашан іске қосылмады',
      serverCeleryStatusOk: 'Сәтті',
      serverCeleryStatusRunning: 'Орындалуда',
      serverCeleryStatusError: 'Қате',

      serverLogsTitle: 'Сервис журналдары',
      serverLogsApiTitle: 'API журналдары',
      serverLogsWorkerTitle: 'Воркер іске қосу тарихы',
      serverLogsLevelAll: 'Барлық деңгейлер',
      serverLogsLevelInfo: 'INFO',
      serverLogsLevelWarning: 'WARNING',
      serverLogsLevelError: 'ERROR',
      serverLogsTotalBuffered: 'буферде жазба',
      serverLogsEmpty: 'Журнал буфері бос',
      serverLogsWorkerEmpty: 'Іске қосу тарихы бос',
      serverLogsColTime: 'Уақыт',
      serverLogsColLevel: 'Деңгей',
      serverLogsColLogger: 'Логгер',
      serverLogsColMessage: 'Хабар',
      serverLogsWorkerColStart: 'Іске қосу',
      serverLogsWorkerColFinish: 'Аяқталу',
      serverLogsWorkerColStatus: 'Мәртебе',
      serverLogsWorkerColTenders: 'Тендерлер',
      serverLogsWorkerColNotifs: 'Хабарландырулар',
      serverLogsWorkerColErrors: 'Қателер',

      // Extended log system
      serverLogsCopyToClipboard: 'Көшіру',
      serverLogsCopied: 'Көшірілді!',
      serverLogsScrollToBottom: 'Төменге',
      serverLogsServiceApi: 'API',
      serverLogsServiceMongo: 'MongoDB',
      serverLogsServiceRedis: 'Redis',
      serverLogsServiceWorker: 'Воркер',
      serverLogsLimitRows: 'жол',
      serverLogsSourceAll: 'Барлық көздер',
      serverLogsSourceAccess: 'HTTP сұраулар',
      serverLogsSourceApp: 'Қолданба',
      serverLogsSourceSystem: 'Жүйе',
      serverLogsMongoTitle: 'MongoDB ішкі журналы',
      serverLogsMongoInfo: 'MongoDB жад буферінен соңғы жазбалар',
      serverLogsMongoEmpty: 'MongoDB журналы бос',
      serverLogsRedisTitle: 'Redis Slowlog',
      serverLogsRedisInfo: 'slowlog-log-slower-than шегінен асқан сұраулар',
      serverLogsRedisEmpty: 'Slowlog бос',
      serverLogsRedisThreshold: 'Шек: {n} — осыдан баяу пәрмендер жазылады',
      serverLogsRedisColId: '#',
      serverLogsRedisColTime: 'Уақыт',
      serverLogsRedisColDuration: 'Ұзақтық',
      serverLogsRedisColCommand: 'Пәрмен',
      serverLogsWorkerDetailTitle: 'Воркер толық журналы',
      serverLogsWorkerDetailInfo: 'Celery тапсырмалары ішіндегі негізгі оқиғалар',
      serverLogsWorkerDetailEmpty: 'Толық журнал жоқ',
      serverCeleryStale: 'Воркер кестеден ұзақ іске қосылмады ({n} мин.)',
    },
  }
};

export type Language = 'ru' | 'kk';
